<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12">
				<h1 v-if="$vuetify.breakpoint.smAndUp" class="band-color-blue interview-title">
					Day 2 - Washington D.C.
				</h1>
				<h1 v-else class="band-color-blue interview-title-sm">
					Day 2 - Washington D.C.
				</h1>
			</v-col>
			<v-col cols="12">
				<p class="band-color-blue word-salad">
					(Counter Attack, Clinton’s Clowns: Gates &amp; Schmidt, Hillary &amp; Bill Clinton’s Role, Secret Treatises, Hillary’s Data Alliances, Wiping Down The Crime Scene, East Egg vs. West Egg, Nursing School Desertion, Joyriding With Debby DoNothing, Baracks Phone Calls, Holding Children Hostage, A Lousy Encyclopedia Salesman, Wife-Queen-Wife, This Woman’s Work, Fueling Up The Yachts, A Better Man, War Child, Always In Second Place, No Son Of Mine, Focus on Abortion, Kings Castle, Torn Between Two Continents, Woman In Chains, It Never Snows In LA, Give To Live, Unequal Alliance, Losing Your Rembrandt, 8 Million Ways To Lie, Headwaters Of The Filth, My Own Strange Path, Exorcism, The Quest For Immortality, Rockets To Nowhere, King Barack, How To Disappear Completely, Chalk And Cheese, Vanquished From The Kingdom, Obama’s Young Philanthropists, Childhood Influences: Bill &amp; Hillary Version, Exploring Immortality, Obama Administration, Child Of Vision, The Enforcer, The Race Without A Toe, Feeling Ugly Inside, Grandmas Pilgrimage, The Right To Lose, Not A Bright Child, Lost Weekend: 8 Year Version, Earning Knowledge, Billion Dollar Babies, The Big Money, All The Girls Love Alice and more…… See Timeline for Synopsis of Events)
				</p>
			</v-col>
			<v-col cols="12" class="main-text text-border">
				<p class="h-l">
					H.L. Should we get right to it?
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes, we have so much to cover, it’s a massive day.
				</p>
				<p class="h-l">
					H.L. Today we are going to go deeper into the cover-up. Yesterday you talked about the Obama Administration as the primary culprit in the conspiracy and cover-up. But according to the summary you gave me, this is not exactly the case. Do you want to explain this now? I think some clarification is definitely necessary.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Sure, you’re right. Yesterday we did talk about the Obama administration as the main player, and President Obama was essentially responsible for the events we discussed. At the same time, I felt it would be too confusing for the reader to go into each individual responsible. After all, the vast majority of the day was spent on Tennessee; the cabin, drafting and the early response to <span class="italic">The Legacy Letter</span>.
				<span class="break"></span>
				But behind Barack Obama’s actions in relation to the suppression of <span class="italic">The Legacy Letter</span>, it was always Bill Clinton and his enforcer Hillary.
				</p>
				<p class="h-l">
					H.L. I see.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Now all of this will be explained later today as to why and when this suppression by Bill Clinton started. But for now, it is only necessary to understand that the early success of <span class="italic">The Legacy Letter</span>; February through May of 2014, was initially Bill Clinton’s concern and problem, not the concern of President Obama.
				</p>
				<p class="h-l">
					H.L. And Bill Clinton’s ‘enforcer’ Hillary as you said.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes, of course Hillary as well. We will dig into and dissect the Clintons today in a way that they perhaps have never been examined.
				</p>
				<p class="h-l">
					H.L. That sounds exciting.
				</p>
				<p>
					<span class="douglas">Douglas:</span> It will be.
				</p>
				<p class="h-l">
					H.L. Okay so here is the big question, the one everyone is going to want to know. How many days after you sent the first copy of <span class="italic">The Legacy Letter</span> out did it take for the suppression efforts to begin transpiring in Washington D.C.?
				</p>
				<p>
					<span class="douglas">Douglas:</span> Three days.
				</p>
				<p class="h-l">
					H.L. That’s it?
				</p>
				<p>
					<span class="douglas">Douglas:</span> Three days after I sent the first copy of <span class="italic">The Legacy Letter</span> out in February of 2014, on MSN Mail, a Microsoft product; Hillary Clinton formed a partnership with Bill Gates the founder of Microsoft and the Gates Foundation.
				</p>
				<p class="h-l">
					H.L. So what did you do in response to this partnership?
				</p>
				<p>
					<span class="douglas">Douglas:</span> I switched email accounts.
				</p>
				<p class="h-l">
					H.L. And what did Hillary Clinton do in response to you switching email accounts?
				</p>
				<p>
					<span class="douglas">Douglas:</span> She switched alliances, of course.
				</p>
				<p class="h-l">
					H.L. How so?
				</p>
				<p>
					<span class="douglas">Douglas:</span> In a few months I switched exclusively to Gmail, and within a few months, Hillary Clinton went out and switched alliances; recruiting the Chairman of Google and Gmail, Eric Schmidt, for another project.
				</p>
				<p class="h-l">
					H.L. She wanted your data?
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes, she needed my data. She wanted and needed to know to who and where <span class="italic">The Legacy Letter</span> was being sent. She needed to know every single person who received a copy, and the only way to get it as a private citizen was to go to the top; the founder or the chairman of those Companies; both Microsoft and Google.
				</p>
				<p class="h-l">
					H.L. Unbelievable. Well Hillary Clinton was really shadowing you at this point.
				</p>
				<p>
					<p>
					<span class="douglas">Douglas:</span> Definitely, she was. You have to understand at first Barack Obama did not want those suppression operations in regards to <span class="italic">The Legacy Letter</span> anywhere near the White House.
				<span class="break"></span>
				He told Hillary this is your problem, you deal with it. Obama told her he would do what he could do to help her, and he did so in March, but he did not want the operation to suppress The Theorem and <span class="italic">The Legacy Letter</span> run out of The White House in the late winter and early spring of 2014: No way, no how.
				<span class="break"></span>
				He tells her to wait until May. Obama was sure that I would give up, as I had before. Because as you will learn the reasons for later, Barack Obama has been watching me; forced to watch me for six years at this point, and he knows the patterns of my behavior.
				</p>
				<p class="h-l">
					H.L. Obama tells Hillary to wait until May; if you are still at it, still sending out copies of <span class="italic">The Legacy Letter</span> then come back and see him then.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes, and this should show how well <span class="italic">The Legacy Letter</span> was doing, as to the date in May that Bill Clinton picks to visit President Obama.
				</p>
				<p class="h-l">
					H.L. Meaning President Obama told Hillary or Bill, you can come see me in May if things do not improve; he meant ‘sometime’ in May. But Bill Clinton is right there on his doorstep on May 1st, 2014.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes exactly. For example, if you are bothering me and I tell you, “Hey come back and see me sometime in the summer”. Then, the first day of summer, the first day of the summer solstice, you show up at my doorstep; well then you are likely pretty desperate to sell me something.
				<span class="break"></span>
				Or as in this case, you are very desperate for my assistance in some way. So in Bill Clinton’s case, he needed Barack Obama’s assistance immediately! He couldn’t wait until May 10th or May 20th. When Obama said May he was being vague; Bill Clinton could not wait, he could not take any chances.
				</p>
				<p class="h-l">
					H.L. And in some ways Obama should have listened to Clinton right?
				</p>
				<p>
					<span class="douglas">Douglas:</span> Absolutely. You see Bill Clinton is a wise and experienced statesman at this point; he sees the big picture. He knows I am sending out 50 to 100 copies of <span class="italic">The Legacy Letter</span> every day. So he realizes the mushrooming effect; he sees the coming storm. He sees the problem compounding every day.
				</p>
				<p class="h-l">
					H.L. Bill Clinton by now has read <span class="italic">The Legacy Letter</span>, he realizes this is not just some half-baked attempt to get money; he realizes that it is very successful letter, and the billionaires are calling you on the phone. This is serious and he tells Obama as much.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Sure, but President Obama is having none of it. He doesn’t like Bill Clinton to begin with. He doesn’t like another man showing up unannounced at his castle either, and by 2014 the White House is definitely Barack Obama’s castle.
				</p>
				<p class="h-l">
					H.L. Especially with demands.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Especially with demands. No man likes another man showing up at his castle with demands, and likely Bill Clinton had many. He wanted the full efforts of the Obama Administration to shut this down, to shut down my operation; NSA packages, harassment of my potential donors and investors, and prosecutions if necessary. And boots on the ground in regards to physical surveillance of the Tennessee cabin.
				<span class="break"></span>
				He was likely telling Obama at this stage about the logistical and surveillance nightmare our Tennessee residence was; how the surveillance guys, the private ones, refused to go up into the woods to install cameras and listening devices because of the bears. Clinton would have shared his frustration with Obama as to what he was indirectly hearing from the field.
				</p>
				<p class="h-l">
					H.L. And Obama is telling him what?
				</p>
				<p>
					<span class="douglas">Douglas:</span> Well, that he knows me. He knows my behavior and tells Bill Clinton to relax.
				<span class="break"></span>
				He says just as likely as I continue tomorrow to send out Legacy Letters, I will just as likely take off for another international exodus. I will just as likely run; go to South America or to Asia, as to stay in Tennessee. This was my pattern before, and again we will go into why Barack Obama knows all of this later in the week.
				<span class="break"></span>
				He reminds Clinton of all the places I have been since 2008. To Barack Obama, I am flaky. So he doesn’t like Bill Clinton because the way he treats women, treats Hillary. And he doesn’t like me because I am flaky.
				<span class="break"></span>
				These are two character traits and behaviors he prides himself in not possessing, so from his logic he sees nothing good coming out of them.
				</p>
				<p class="h-l">
					H.L. Yet here Obama is mistaken. Bill Clinton is a Rhodes Scholar and a two term president and you have made the largest discovery in human psychology.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Exactly, but Obama doesn’t see things this way, especially at this point.
				<span class="break"></span>
				It is hard to explain, but his mind doesn’t work like that. It just doesn’t. Barack Obama prides himself in his ethics, in his character. And he doesn’t see any of his character traits, enough of them at least in either Bill Clinton or me to pose a threat to his comfort at this point.
				</p>
				<p class="h-l">
					H.L. That makes sense. So therefore because the lack of the character traits he dismisses the threat.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, but Bill Clinton knows me well, and had known about me much longer than Barack Obama ever had. As we will see later, he knew of me ever since he was president, ever since 1995. He sees something different in my behavior now; a more mature and powerful writer, a more mature man. He sees the changes.
				<span class="break"></span>
				Bill Clinton can see things in people that Barack Obama cannot; he can see that accomplishment, success and great achievement to the level we had both diversely acquired is not always a straight line pursuit. He tries to convey this to Barack Obama, but it negates his mental processing and Obama shuts down.
				</p>
				<p class="h-l">
					H.L. So Clinton saw the big picture, the real threat. He realized you had changed, but as you say Obama is limited in his world view by his rigid belief system at this point. That makes sense.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes of course, and who can blame Barack Obama at the time? His rigid belief system had worked almost flawlessly for him in 2014.
				</p>
				<p class="h-l">
					H.L. I agree. Barack Obama is now a two-term president like Bill Clinton was. So suddenly Clinton’s wise, old advice is not that important. Obama is his own man, his own president, as he sees it at this point.
				</p>
				<p>
				<span class="douglas">Douglas:</span> That’s right, and with Hillary long gone out of Obama’s hair, he can focus his agenda the way he wants it.
				<span class="break"></span>
				Remember, this was to be the year of action; 2014. Remember, he had promised in January of 2014 that there would be sweeping surveillance reforms. So what Clinton was asking seemed foul on many levels to Obama. It was contrary to where he wanted to go with the final two years of his presidency.
				</p>
				<p class="h-l">
					H.L. That is so true, and funny in a way. I almost forgot about that. In January Obama announces in a speech that he is going to reform surveillance, it‘s a major speech. Of course the next month you start sending out <span class="italic">The Legacy Letter</span> and that reform promise goes out the window.
				</p>
				<p>
					<span class="douglas">Douglas:</span> So true, I bet he would like to have that speech back.
				</p>
				<p class="h-l">
				H.L. I am sure you’re right.
				<span class="break"></span>
				It is fascinating to visualize Bill Clinton there in The White House attempting to convince Barack Obama on the urgency of the situation.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes, and naively Obama downplays it. Of course this will bite him later and very hard. But at this point he tells Bill Clinton to go away and never come back!
				</p>
				<p class="h-l">
					H.L. That is harsh.
				</p>
				<p>
					<span class="douglas">Douglas:</span> It is Obama’s castle, he is the president.
				</p>
				<p class="h-l">
					H.L. Very true. So the Clintons will have to wait until the end of the month. On May 29th Hillary Clinton enters the White House and has a ‘secret lunch’ with Obama, correct?
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes, secret sure. But Obama already told Bill Clinton at the beginning of the month to send Hillary next time, if the situation with <span class="italic">The Legacy Letter</span> did not improve. He said they would have a lunch; it was all informally planned and just not announced.
				</p>
				<p class="h-l">
					H.L Hillary gets the job done.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, Obama agrees to take over operations to suppress <span class="italic">The Legacy Letter</span> from the White House, as he had to admit the letter was getting out of control. The momentum was almost unstoppable at that point.
				<span class="break"></span>
				While he will not admit to Hillary that Bill Clinton was right, at the same time, he gives her what she wants. She gets the full suppression and surveillance package. The one Bill Clinton suggested earlier.
				</p>
				<p class="h-l">
					H.L. You say even Obama had to admit the popularity of <span class="italic">The Legacy Letter</span> needed to be squashed at that stage. Is this because of the international phone calls, the ones from world leaders he is getting at this point?
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes, but you are jumping ahead. The phone calls had already started yes; Obama knew he had to do something at that point.
				</p>
				<p class="h-l">
					H.L. So at the end of May, when Obama took over, you realized this impact in Tennessee?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, dramatically, and right away. In fact I believe that is how I knew about the ‘secret’ meeting’. I looked around our Tennessee residence and could see sweeping changes in the quality of our surveillance. Then, sure enough a few days later, up on my browser pops some news story about Hillary showing up unannounced for a hush-hush lunch at The White House.
				<span class="break"></span>
				We went over all of that yesterday I thought; the increase in surveillance.
				</p>
				<p class="h-l">
					H.L. Just trying to keep the timeline straight.
				</p>
				<p>
				<span class="douglas">Douglas:</span> No I understand. That’s a good idea.
				<span class="break"></span>
				Actually there is something then I want to point out. I think it is really imperative to the make sure the reader notices the subtleties and intricacies within the timeline now. Because if we don’t explain them; then later when these major actions occur in relation to Barack Obama and Hillary Clinton they will not make any sense. They will seem to pop out of nowhere.
				</p>
				<p class="h-l">
					H.L. I agree. That’s a good point, like for instance the tension between President Obama and the Clintons?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Sure. But that is just a small part of it right? I mean Barack Obama’s failure to listen to Bill Clinton’s advice; by waiting that month is going to yield other problems.
				<span class="break"></span>
				It is going to give me 28 days unobstructed, and in those 28 days I will send out likely 350 to 500 Legacy Letters. I will send them out with the momentum building, and positive responses coming back.
				</p>
				<p class="h-l">
					H.L. That’s a lot.
				</p>
				<p>
				<span class="douglas">Douglas:</span> It is a large number of Legacy Letters and to some of the wealthiest people in the world; the most powerful. So imagine being behind that? His problems are going to snowball. President Obama will be trying to catch the wind essentially.
				<span class="break"></span>
				Therefore the excitement connected to <span class="italic">The Legacy Letter</span> is going to go unchecked by Barack Obama for 28 days; this at a crucial time. All these little things, these seemingly small mistakes, will be important later.
				</p>
				<p class="h-l">
					H.L. And you think much of these early mistakes are due to Barack Obama’s inability to grasp your motivation, your persistence at this stage.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, but I believe it is even deeper. I think we really are getting to the limitations of President Obamas’ leadership ability when dealing with intangibles; these traits in me that Bill Clinton understood, as they were the same ones Clinton had in him. They were foreign to Barack Obama. So this is going to be a big problem later. Obama sees a profile in his mind, and it is a set profile of me, a very rigid one. And this goes back to life experience and Barack Obama’s lack of it.
				<span class="break"></span>
				While he has been watching me, forced to do so, he fails to understand me. He doesn’t know about those subtleties of behaviors.
				</p>
				<p class="h-l">
					H.L. So he really should have listened to Bill Clinton.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes, he really should have. Obama is amazingly successful in so many ways. It is not what I would say is a flaw in character by not understanding Clinton or myself. Nor, was he out of his league necessarily in a negative way; more like both Bill Clinton and I are in a parallel foreign league, one that spoke a different language, one that Obama could not understand.
				</p>
				<p>
					Does that make sense?
				</p>
				<p class="h-l">
					H.L. Yes I think so. He has a formidable opponent with you that he is certainly undervaluing.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Some of that is true, but he just lost in Bill Clinton his best asset to stop me.
				<span class="break"></span>
				If it were a different world; if he trusted Bill Clinton and asked him, “What do you think we should do about this Legacy Letter?” Likely Clinton would have known how to deal with me, how to deal with the letter. And the vast majority of these events would not have occurred.
				</p>
				<p class="h-l">
					H.L. So it’s the bureaucratic mind vs. the artistic mind?
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes, exactly. That’s very good. Because Bill Clinton was more than just a politician, he was a political artist. And I am more than a theorist; I am a writer, with a weighted background in literature. So yes, I am an artist as well.
				</p>
				<p class="h-l">
					H.L. Well you were certainly living like one, certainly not like a bureaucrat.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Thank you for reminding me.
				</p>
				<p class="h-l">
					H.l. You brought that one on yourself
				</p>
				<p>
				<span class="douglas">Douglas:</span> Agreed. We really were living on the edge.
				<span class="break"></span>
				So Obama’s clinging to the bureaucratic line of reasoning here is not going to help him, as he enters these multiple dimensions of The Theorem; a discovery beyond belief, and in me; a drive beyond reason, and a life well beyond his exposure.
				</p>
				<p class="h-l">
					H.L. And if your mind is bureaucratic, dealing with one who is an artist can be frustrating.
				</p>
				<p>
				<span class="douglas">Douglas:</span> That’s right, especially when that bureaucratic mind is going to break the law; and that is exactly what he is about to do.
				<span class="break"></span>
				While it sounds bizarre, I could actually feel an aura of disdain radiating off of him in regards to me the entire time I was in that cabin. To Barack Obama nothing has value unless it’s accomplished in his strict, structured view. To Obama, for us to live like we did, almost like animals with one singular focus in mind; one driving goal, a razor sharp desire to succeed or to die in the process was dangerous and illogical.
				</p>
				<p class="h-l">
					H.L. But sometimes that level of commitment is what it takes.
				</p>
				<p>
				<span class="douglas">Douglas:</span> So true. It almost always takes that. In fact that is what it’s all about.
				<span class="break"></span>
				But this tension of me being so foreign to him is going to severely challenge him and up the stress level right away. Because the Obama administration had kept me deep asleep for a long time; six years, but finally I was awake, and I wasn’t going back to sleep anytime soon.
				</p>
				<p class="h-l">
					H.L. All of this will compound for Barack Obama later; the stress, the fraying relationship with the Clintons, the month of waiting, his inability to understand his opponent and his failure to listen to Bill Clinton’s advice. Is that what you are saying?
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes and I think you could weigh the last item on your list the heaviest. Not listening to Bill Clinton here will ultimately be his downfall. Barack Obama doesn’t trust men, and especially men who are different and with different priorities than him. We may go into the reasons for this later, but you can bet it’s lifted right from his childhood experience.
				</p>
				<p class="h-l">
					H.L. I see.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Barack Obama at this point of his life, in 2014, has spent his time on an upward trajectory. What was put in front of him he accomplished, and accomplished in an outstanding manner: college, his law degree, lecturer, U.S. Senator and now he’s President of The United States. These are amazing accomplishments, essentially the American Dream and beyond. But…
				</p>
				<p class="h-l">
					H.L. But what?
				</p>
				<p>
					<span class="douglas">Douglas:</span> Well the thing with that parochial life path, those finely tuned and focused goals, if you fail along the way you have something to fall back on. If he didn’t become a senator he could have taught law; if he failed at teaching law, he could have made a living as a practicing lawyer.
				</p>
				<p class="h-l">
					H.L. And you had nothing to fall back on. Is that what you are saying?
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes, exactly where I was going with this. You know he is about to face an opponent in myself who is so absolutely opposed to those same goals he strives to obtain.
				<span class="break"></span>
				To me, the way I was taught by my father, the parochial life path was settling and comfortable. I was raised in the opposite way. I was raised to never be comfortable. My father said you will have plenty of time to be comfortable in the grave. If you are not in pain, you’re not growing. And if you are not growing you are not alive.
				<span class="break"></span>
				So in many ways I held Barack Obama’s life and lack of character, at least in a creative and self-exploratory sense, in similar disdain and contempt as to that which he held mine.
				</p>
				<p class="h-l">
					H.L. Fascinating. And you are about the same age as well. He is only a couple of years older.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Sure, and we are about to embark on a battle; both opponents convinced they are right, and this battle is going to cost the American taxpayers hundreds of billions of dollars. It’s going to consume an entire 6 years of American History; and in many ways, it will steal six years of world history. It is going to derail the focus of an entire first term of a Presidency in that of Donald Trump. It’s going to cost countless men and women their careers; their marriages, their livelihoods, and even their reputations. The list goes on and on.
				<span class="break"></span>
				But it all comes down to a philosophy of action and accomplishment. I saw the world one way, and it netted me the largest discovery, perhaps the largest intellectual discovery in the history of mankind; the very origins that define us all.
				<span class="break"></span>
				On the other side of the ring, is a brilliant Harvard educated lawyer; a man who overcame an impossibly painful childhood to obtain heights dizzying to even ponder. At this time, in 2014, President Barack Obama is a man who holds the entire race of a people on his back, and an entire Nation on his shoulders.
				</p>
				<p class="h-l">
					H.L. Both are convinced you are right, and both have the track record to back it up, only in different fields. Both have accomplished the seemingly impossible. It is going to be some battle.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes, it is. And no need for a spoiler alert, Barack Obama is going to win at this point. He is going to ultimately succeed with almost every battle that is put in front of him. But again, the war is far from over, as history will determine its date of completion.
				<span class="break"></span>
				He will win, but the price will be astronomically high. It will almost cost him his life in 2017, and it will almost cost me mine in 2019; this struggle. Others will not be so lucky.
				<span class="break"></span>
				It is a massive undertaking, and unless you are a billionaire, or are some connected wealthy or political elite you would not have had a clue that the battle was even raging. You would scratch your head like millions of others, like the bank teller and say, “I know something is going on, but I don’t what it is.”
				</p>
				<p class="h-l">
					H.L. Yes, but everyone could feel it, everyone knew something was going on. The only difference is that we are going to define it, to reveal it.
				</p>
				<p>
					<span class="douglas">Douglas:</span> That we are doing. We are going to give it everything we have in us and more to explain this colossal mess.
				</p>
				<p class="h-l">
					H.L. Here is the irony of course. This may very well cost Barack Obama his legacy, the very title of the letter that began this war.
				</p>
				<p>
				<span class="douglas">Douglas:</span> That is very good, I didn’t even think of that. The irony is substantial, I will agree.
				<span class="break"></span>
				Actually it may cost both of us ours.
				</p>
				<p class="h-l">
					H.L. So maybe you could explain a little more about this unique underlying philosophy that your father taught you about? Maybe the readers will be interested in it.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Sure, well The Theorem was a perfect example of this. I was not a neuroscientist. I was self-taught, self-financed. If the behavioral model was not perfect, no one would have been interested in it; no one. The Theorem would have never been published. I had to be perfect; the model had to be flawless.
				<span class="break"></span>
				I had to go big or go home, and I had no home to go to. I had no safety net. And if I found myself with one, which somehow was slipped underneath me, I would cut the line to make sure it dropped. It is an absurd method of living life. I wouldn’t recommend it for anyone, ever; not even to my worst enemy. It is reckless for lack of a better word, absolute reckless insanity.
				</p>
				<p class="h-l">
					H.L. But in many ways, this is how a large percentage of the billionaires live, believe and operate. Many drop out of college, when they could have easily obtained their degree. It is a high ratio, I don’t know the number off-hand, but many would not finish school, as they saw things the same way you do.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Very perceptive; another good point.
				</p>
				<p class="h-l">
					H.L. Do you think that was another appeal to <span class="italic">The Legacy Letter</span>?
				</p>
				<p>
					<span class="douglas">Douglas:</span> I think so yes, and I could go beyond that even. I think two people can read <span class="italic">The Legacy Letter</span> and get completely different perceptions of it.
				<span class="break"></span>
				In fact, I have a friend who just recently read the letter and enjoyed it. His first reaction was, “Wow, you are really going after the medical community!”  He liked that part of it. But I never saw that aspect; it wasn’t my intention at all. Of course he is not wealthy.
				<span class="break"></span>
				But then a billionaire reads it, and they see something totally different. There are filters all over that letter, and to get through the filters and get the entire view of it you have to have a massive amount of success and wealth, and belief that it is all or nothing. After looking at <span class="italic">The Legacy Letter</span> thousands of times when sending it out, this is my summation at least.
				</p>
				<p class="h-l">
					H.L. I can see that; two or more different ways to interpret the same words. That seems appropriate.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Should we go back to the events, we have a long way to go. We haven’t even scratched the surface yet.
				</p>
				<p class="h-l">
					H.L. Yes.  In late March 2014, just a little over a month and a half after you send out the first copy of <span class="italic">The Legacy Letter</span>, Barack Obama holds a young philanthropist summit at the White House. He invites many of the children of the adult billionaires you have sent <span class="italic">The Legacy Letter</span> to; the ones that are interested in investing or donating to The Theorem and the discovery behind it. Correct?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well, you are really anxious to get the war started? Enough of the prelude, you want to jump right to the first battle.
				Well the first battle was like the First Bull Run, it did not go well for the president.
				</p>
				<p class="h-l">
					H.L. I agree; it went terribly in fact.
				</p>
				<p>
					<span class="douglas">Douglas:</span> President Obama decides if he can’t get to the hearts and the minds of the billionaires, he will get instead to the hearts and minds of their children. He invites 100 hundred young philanthropists to The White House like you said.
				</p>
				<p class="h-l">
					H.L. That’s just bizarre.
				</p>
				<p>
					<span class="douglas">Douglas:</span> It really is. I mean, I guess his thinking was maybe he could have them talk to their parents and try and convince them not to donate to The Theorem. The whole plan was ludicrous.
				</p>
				<p class="h-l">
					H.L. It is very weak I will say that. It revealed a substantial amount of weakness, on Obama’s part.
				</p>
				<p>
					<span class="douglas">Douglas:</span> He should have just picked up the phone and called their parents and either asked them, or told them directly, “Do not invest!” After all you are the president. Don’t hold their children hostage.
				</p>
				<p class="h-l">
					H.L. That’s a little harsh, but in a way I agree.
				</p>
				<p>
					<span class="douglas">Douglas:</span> The only thing I can compare it to, would be this:
				<span class="break"></span>
				Let’s say my son is seven years-old. His friend Bobby is also seven. They are just little kids.
				<span class="break"></span>
				Now, I know Bobby’s dad is on the local planning commission. I have a problem, as my business needs an easement for expansion. I am too nervous however to go and talk to Bobby’s dad. So I pull little Bobby aside one day, and tell him to ask his father if he will grant this easement for my business.
				</p>
				<p class="h-l">
					H.L. The kid, Bobby, is totally confused.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Absolutely confused. This is so inappropriate, it’s not even funny. This is so weak like you said; you can’t invent this stuff I am telling you. And this is the man who is negotiating for our country?
				<span class="break"></span>
				So when Bobby goes home and tells his dad, or asks his dad about the easement, what do you think the reaction by his father is?
				</p>
				<p class="h-l">
					H.L. Don’t ever go to that house again!
				</p>
				<p>
					<span class="douglas">Douglas:</span> Or worse. If someone did that to my kid, if someone used my son that way; well I would be furious and head right over to their house and raise hell! I imagine you would too.
				</p>
				<p class="h-l">
					H.L.  Yes, I would. That was a very bad move.
				</p>
				<p>
				<span class="douglas">Douglas:</span> The thing is this is American History. How do you write this into the history books? This isn’t some guy on your block; this is The President of the United States.
				<span class="break"></span>
				At this point, I am an obscure intellectual with a behavioral theory not yet accepted. What is going to happen when he is talking to someone perceived as an equal? When he talks to another World Leader?
				</p>
				<p class="h-l">
					H.L. As you said that is coming soon. Right?
				</p>
				<p>
					<span class="douglas">Douglas:</span> Okay, so yes he is going to get phone calls, likely they are going to start in April or May of 2014 and continue all through the summer and into the next year. And no, there isn’t an easy way out of them either.
				<span class="break"></span>
				They had to start like this, “Barack, what the hell is going on over there?”
				<span class="break"></span>
				These are world leaders calling him. Remember, I said that most of the billionaires in foreign countries have friends who are the leaders of those countries. Many of those billionaires received <span class="italic">The Legacy Letter</span>.
				</p>
				<p class="h-l">
					H.L. Yes, you said that already.
				</p>
				<p>
				<span class="douglas">Douglas:</span> What I didn’t tell you, and what you might already know, is that these billionaires are often big donors to their country’s research institutions and colleges.
				<span class="break"></span>
				In fact some of these great men even have research hospitals and wings of hospitals named after them. So you can already see where this is going right?
				</p>
				<p class="h-l">
					H.L. Sure, I can certainly visualize it. The billionaire takes it to the hospital or research administrator and everything rolls down hill. After all he is a big donor, perhaps the biggest, and he is interested. So looking at The Theorem becomes a priority.
				</p>
				<p>
					<span class="douglas">Douglas:</span> That’s it. And they love it. The neuroscientists always have, and from the beginning. So this gets back to the billionaire, who out of respect for the leader of his country, checks with him before donating or investing. So the leader is now befuddled by these events. What is happening, why doesn’t anyone know about this?
				</p>
				<p class="h-l">
					H.L. The leader then calls President Obama to see what in the world is going on.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Of course they do. Why wouldn’t they? This is exciting. I have chosen their country, their billionaire. This means a lot to them, suddenly I mean a lot to them. They are honored, and I am deeply honored by their interest.
				</p>
				<p class="h-l">
					H.L.  And as for a reason they should not allow their billionaires to donate or invest. What does President Obama tell them then? What can he do?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Lie, all he can do is to lie to them.
				<span class="break"></span>
				But they are not going to believe him, not for a minute. Obama is not a neuroscientist, what is he going to say? There is nothing he can say. All he can do is give them whatever they want, anything but this. So now of course he opens up the checkbook. It’s all he can do.
				<span class="break"></span>
				Maybe in some cases, likely in many, he can play the friendship card. In 2014, President Obama is still very popular internationally. He can promise a visit. But ultimately he will pay, with all the equity and negotiating victories he has accomplished; all will be gone.
				<span class="break"></span>
				When word gets out, and it did later, his problems would only multiply. “Hey go see Barack, tell him one of your billionaires wants to invest in The Theorem, and money to your country will flow.”
				</p>
				<p class="h-l">
					H.L. And the taxpayers foot the bill.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes, of course.
				</p>
				<p class="h-l">
					H.L. It’s sad. Meanwhile you are up in the mountains of Tennessee scourging for a pack of cigarettes.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Right. My life is falling apart, but as you can see his is too.
				<span class="break"></span>
				Ultimately he will win by losing. After all they know him. As intriguing as The Theorem is, they don’t know me, they know him. And again this is the president of one of the most powerful countries in the world.
				<span class="break"></span>
				The thing is though, how are you going to lie to some of these people? Take for instance Vladimir Putin, who spent many years in the KGB; he probably knows you are lying before you even begin to formulate your lie. I imagine those conversations were interesting.
				<span class="break"></span>
				And this is going to go on for years. I will soon be out of Tennessee, free of the mess and stress. But for Barack Obama the nightmare is just beginning. Everyone will have their hand out; he is giving out the best Halloween candy in the neighborhood. American greenbacks are very valuable!
				<p class="h-l">
				H.L. Yes, but there’s more to it isn’t there? It’s almost hoarding, as America is keeping this discovery to itself.
				<span class="break"></span>
				What does the billionaire who was so enthusiastic say when he goes back and tells the hospital administrator? It would be embarrassing.
				</p>
				<p>
				<span class="douglas">Douglas:</span> This is so true. One thing is for sure, billionaires do not like to be embarrassed.
				<span class="break"></span>
				So you have this growing animosity towards America, towards President Obama. These world leaders are bright men; brilliant women and men. They are educated at the best universities in the world. Often times they even attended our own Ivy League Schools. They are not slouches. They can take one look at <span class="italic">The Legacy Letter</span>, and know more about me and more about The Theorem than most could ever comprehend. Obama was fooling no one. All the world leaders knew immediately; they could see his denials were politically motivated.
				</p>
				<p class="h-l">
					H.L. They probably also saw it as another example of American arrogance.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Sure, I think so. But the problems are just starting for Obama and the Clintons right?
				</p>
				<p class="h-l">
					H.L. What do you mean?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well it is not just the international billionaires and the world leaders he is going to have to answer uncomfortable questions from, because there are plenty of problems he is going to face right here at home.
				<span class="break"></span>
				In the United States, the billionaires here are often friends with the wealthy socialites and these people had a long and storied history of philanthropy on the East Coast.
				</p>
				<p class="h-l">
					H.L. The plot thickens. Enter the 'Old Money'. I know it well.
				</p>
				<p>
				<p>
					<span class="douglas">Douglas:</span> Yes, of course you do; but for the readers I will explain.
				<span class="break"></span>
				In fact, this is exactly what it is all about: <span class="italic">The Legacy Letter</span> and The Theorem. This type of letter, with deep intellectual content and a controversial behavioral theory; well, this was right in these elite backers’ wheelhouses.
				<span class="break"></span>
				Now this goes back to royalty, it goes back hundreds of years and crosses oceans and continents. The wealthy elite like to have any breakthrough discovery first.
				</p>
				<p class="h-l">
					H.L. Sure they do, so they can vet it out, and make sure they end up on the right side of all the new changes.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Correct, before it filters down to the masses. So this is where The Theorem ultimately would end up; along with its newly introduced coincidental prelude: <span class="italic">The Legacy Letter</span>. It was the end of the line essentially. This is where the decisions would be made in many cases.
				</p>
				<p class="h-l">
					H.L. And they were interested?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, very much so. It was a once in a lifetime chance for these philanthropists to change the intellectual landscape of our Nation. It was a big deal to them.
				<span class="break"></span>
				Now they are being told that they cannot do this?
				</p>
				<p class="h-l">
					H.L. Not a good idea.
				</p>
				<p>
					<span class="douglas">Douglas:</span> No, not a good idea at all.
				<span class="break"></span>
				Add this to the fact that the Democratic Party is supposed to be about free speech, and artistic expression. Then suddenly you smack that down and suppress that freedom?
				<span class="break"></span>
				So the Clintons and Barack Obama are going to fight an uphill battle here like they never could have imagined. They are paddling upstream, up a river and the current is about to get much stronger.
				</p>
				<p class="h-l">
					H.L. Absolutely, they are outsiders for one thing.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, and that is a very good point. I was just getting to that.
				<span class="break"></span>
				Here is the other thing; these moneyed elite of the East Coast, they are well-above the intellectual level of both the Clintons and Barack Obama. They have experienced culturally so much more than them, and for generations. The Clintons or Barack Obama could be seen as ‘new money’ or ‘new power’, as they were first generation successes. This is in contrast, to those in this area who had been affluent, articulate and influential for many generations.
				<span class="break"></span>
				So there is a subtle pecking order among the moneyed elite and powerful East Coast Philanthropy Community, and the Clintons and Barack Obama are way down the list.
				<span class="break"></span>
				And again, they are ordering them around, telling them they cannot invest and donate?
				</p>
				<p class="h-l">
					H.L. One more thing, being president is not impressive to these aristocrats; in many cases it just doesn’t pay enough. They all feel they could be president if they wanted to be. Some of them are right.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes, it’s not going to get any easier, from here on in. These three are in way over their head. They were extremely overmatched.
				</p>
				<p class="h-l">
					H.L. That is so true. From your description, I can almost visualize an old Three Stooges movie, but now the cast is different. Bill, Hillary and Barack clumsily stumbling around this vast lawn of the mansion of one of these ‘old money’ families, trying to interrupt an outdoor summer party by snatching the checkbooks out of the hands of the donors.
				</p>
				<p>
					<span class="douglas">Douglas:</span> And you said I was harsh.
				</p>
				<p class="h-l">
					H.L. It just came to mind.
				</p>
				<p>
				<span class="douglas">Douglas:</span> I guess it did.
				<span class="break"></span>
				So, the loyalty these wealthy elite had to the Democratic Party, to the Clintons was fraying. It was never as strong as the Clintons thought it was, this is what they were realizing.
				<span class="break"></span>
				Their democratic platform was dated, a part of the past. Then, when <span class="italic">The Legacy Letter</span> came along, it represented a direct contrast to that dreary portrait they had painted. The Clintons were in fear of losing everything they convinced themselves they had. They were hemorrhaging; grabbing at the ankles of these wealthy individuals and trying to pull them back into the past. While I was trying to pry them off the same old rock they had been pinned against for the last 30 years.
				<span class="break"></span>
				It was quite a battle. Again, and it wasn’t intentional on my end, somehow this just happened.
				</p>
				<p class="h-l">
					H.L. I can also see that New York was Hillary Clintons’ territory.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes, and Obama had just six years earlier bailed out Wall Street and the banks. So they saw me as trampling through their territory essentially.
				</p>
				<p class="h-l">
					H.L. Even though that wasn’t your intention?
				</p>
				<p>
					<span class="douglas">Douglas:</span> It wasn’t at all. I just saw the Clinton’s and Obama as bureaucrats, if I even saw them at all.
				</p>
				<p class="h-l">
					H.L. More like fellow employees.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Sure, I guess you could describe it that way. The New York billionaires were both of our bosses. That’s how I saw it. I know that sounds strange, but that again is how I saw things.
				<span class="break"></span>
				But none of this was intentional like I said.
				</p>
				<p class="h-l">
					H.L. Maybe a little naïve though, certainly you must have had some idea.
				</p>
				<p>
					<span class="douglas">Douglas:</span> No, not at first.
				</p>
				<p class="h-l">
					H.L. Yes, but you must have realized that The Theorem, in your original press release was going right at the very throat of a central tenet of the Democratic Platform; the right to choose in regards to abortion.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Pro-life or pro-choice just wasn’t the focus of my marketing and had not been for years in relation to The Theorem.
				<span class="break"></span>
				At the same time, I will always hold the Pro-life Community in high regard, as they were a large contributing factor in regards to <span class="italic">The Theorem: A Complete Answer to Human Behavior</span> being on the actual bookshelves in bookstores. In contrast to at least 40,000 others books published in the US in 2006 that never even made it into the bookstores at all. For this, I will be forever grateful.
				<span class="break"></span>
				At the same time The Theorem is obviously so much more, as this was just a slice of our marketing. So at the time, in 2014, I was only focused on the behavioral model and on the disorders and behaviors that The Theorem solved the mysteries to; autism, depression, panic disorder, OCD, anorexia, the purpose of sleep and dreams, and the reproduction model among others.
				</p>
				<p class="h-l">
					H.L. Well true, there is not a single word in <span class="italic">The Legacy Letter</span> about abortion. It just wasn’t headed in that direction. Still you must have had an idea?
				</p>
				<p>
				<span class="douglas">Douglas:</span> No, I told you I really had blinders on; falsely assuming that since I wasn’t thinking about it, no one else was. My mind just works different that way.
				<span class="break"></span>
				I will give you an example if we have space. Do we?
				</p>
				<p class="h-l">
					H.L. Sure.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Well not to indulge in self-degradation. But this will show how my brain works or doesn’t work.
				<span class="break"></span>
				When I was a little kid growing up in Southern California it snowed once in December. Of course snow in Southern California is very rare. So I couldn’t wait to go across the street and tell my best friend Kevin about it.
				<span class="break"></span>
				Well unfortunately he was sick that day. Kevin’s mother, who was a nurse, told me he couldn’t come out and play. But I could see him there, past her, on the couch with a thermometer in his mouth and under a blanket. So I said to him, “Hey Kevin, I will go and get you some snow!”
				</p>
				<p class="h-l">
					H.L. Sure you didn’t want him to miss out on the fun.
				</p>
				<p>
					<span class="douglas">Douglas:</span> But here’s the thing, his mom shut the door and like 10 minutes later I came back with some snow. So she asked where I went. I told her I had to go to my house to get the snow. She then informed me of the obvious.
				</p>
				<p class="h-l">
					H.L. That there was snow right out front of their door.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yeah, what a dunce right? In my mind where I saw the snow first I had to return to.
				<span class="break"></span>
				You know to this day, I will never forget the look on that woman’s face. It was one of pity, and compassion; it was as if she wanted to say, “Kid you’re going to have a rough time in life!” That is a true story.
				</p>
				<p class="h-l">
					H.L. Yet you can solve perhaps the biggest riddle in psychology.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Not just one, but so many. In Nature there is always balance. Like I said, my brain is wired differently.
				<span class="break"></span>
				I had no intention of causing anyone in The White House any problems. It just worked out that way. I had no intention of going to war with anyone, especially not with a sitting president. I was just fulfilling my obligation to the discovery. That is how I saw it, nothing more.
				</p>
				<p class="h-l">
					H.L.  Well you sure caused some serious disruption.
				</p>
				<p>
				<span class="douglas">Douglas:</span> That is obvious. Not just politically, but for many business leaders as well.
				</p>
				<p class="h-l">
				H.L. Speaking of businessman; how do you feel about Bill Gates and Eric Schmidt allying against you with Hillary Clinton, all in order to mine data out of your personal communications?
				</p>
				<p>
					<span class="douglas">Douglas:</span> Well Bill Gates is a victim too. I am not going to drag his name in the dirt. Again, he is a victim; he just doesn’t know it yet, like so many who were a part of this scandal.
				<span class="break"></span>
				I would not want to be in any of their shoes right now. Not with a president in office with the memory of an elephant and the bite of a pit bull.
				<span class="break"></span>
				Once Donald Trump gets his teeth into something he doesn’t let go. And since these are the same people involved in trying to dethrone him for four years. No thank you!
				</p>
				<p class="h-l">
					H.L. Like you said they are fueling up their yachts and liquidating their stocks, the storm is coming.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Let’s just say it is a good time to be a lowly writer.
				</p>
				<p class="h-l">
					H.L. There certainly is a lot to write about now. But these are grown men; they are old enough to realize the implications of their actions.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Well typically I would agree with you. But in the case of the technology sector and in the case of Hillary Clinton I don’t quite see it that way.
				</p>
				<p class="h-l">
					H.L. What do you mean?
				</p>
				<p>
					<span class="douglas">Douglas:</span> You know the Democratic Party has a somewhat long and storied history of seducing Silicon Valley types. It’s almost as though they harvest that memory of those smelly computer rooms these guys grew up in; the pimple faces and the body odor. To them the Democratic Party is Hollywood and glamour.
				</p>
				<p class="h-l">
					H.L. Well said.
				</p>
				<p>
				<span class="douglas">Douglas:</span> It’s almost like they say, “Come to our party, we will make you beautiful!”
				<span class="break"></span>
				No you can’t. It’s all a lie.
				</p>
				<p class="h-l">
					H.L. The truth is the Democratic Party is really not even the party of Hollywood, as the only president who was an actor was Ronald Reagan; he won as a Conservative Republican.
				</p>
				<p>
					<span class="douglas">Douglas:</span> That’s very observant, I never thought of that. But in reality they are all actors.
				</p>
				<p class="h-l">
					H.L. That is observant as well.
				</p>
				<p>
					<span class="douglas">Douglas:</span> But I believe there is a lesson in all of this. You know there are no shortcuts in life. You can be young and make a lot of money; however, if your social, emotional and mental development is lagging, then someone is going to take that money away from you. Hillary Clinton is more than willing to be that person.
				</p>
				<p class="h-l">
					H.L. She is; who can argue with that? She sees the techies as smaller than her, ants she can step on.
				</p>
				<p>
					<span class="douglas">Douglas:</span> It’s more even. You have to realize how the Clintons see themselves. They really are delusional in a way. They see everyone else as disposable, especially like you said; big tech and Silicon Valley. The Clintons think they are the Kennedys. The problem is that they are too selfish for that.
				</p>
				<p class="h-l">
					H.L. Could you clarify?
				</p>
				<p>
					<span class="douglas">Douglas:</span> Well if you are going to become a dynasty you have to have a lot of children. The Kennedys, Bushes and even the Trumps could end up as political dynasties. But Bill Clinton was too selfish with Hillary’s time to have more kids; and if you can’t have them naturally, you need to adopt them to become a dynasty.
				</p>
				<p class="h-l">
					H.L. Interesting.
				</p>
				<p>
				<span class="douglas">Douglas:</span> And again, I hold no grudges against the billionaires who were in on this.  I see them only as victims of Barack Obama and The Clintons.
				<span class="break"></span>
				I like most everyone I sent <span class="italic">The Legacy Letter</span> to, or I wouldn’t have sent it. I will just say this; there are some billionaires out there who do not love themselves. These people I cannot help.
				</p>
				<p class="h-l">
					H.L.  Very diplomatically spoken.
				</p>
				<p>
				<span class="douglas">Douglas:</span> But I also see Barack Obama most definitely as a victim of Hillary Clinton.
				<span class="break"></span>
				Well, let me put this together better. I see myself as victim of Barack Obama, and he then is a victim of Hillary Clinton, who is herself a victim of Bill Clinton; who is a victim of Virginia Clinton Kelley. The abuse just goes on and on, mirrors reflecting against each other ad infinitum. Until you get back to a war or a famine or a tragedy. In the Clinton case, it was a car accident.
				</p>
				<p class="h-l">
					H.L. That’s very interesting.
				</p>
				<p>
					<span class="douglas">Douglas:</span> But the problem is that when you covet the one who abused you; then you abuse the one who covets you. This is the story of Bill and Hillary.
				</p>
				<p class="h-l">
					H.L. That is a very quotable summation. I may borrow that.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Sure go ahead.
				<span class="break"></span>
				But you can see Bill Clinton out there now rambling on about his mother, still defending her. These people just don’t get it. In fact that entire generation doesn’t get it.
				<span class="break"></span>
				This is why they suffer so many immunological malfunctions; the body can withstand that pain for only so long. As you age your frame cannot contain it. Instead it leaks out of you. And Bill and Hillary Clinton are leaking all over the place. Case in point, this mess we are about to dive into.
				</p>
				<p class="h-l">
					H.L.  This all makes complete sense. They could have saved the world a lot of grief by hiring a shrink.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Oh, I can’t imagine them not having one, maybe a few. They need to fire them. These people, The Clintons, need some disintegrative therapy. They need an exorcism.
				<span class="break"></span>
				I mean, don’t get me wrong, being abused is often a progenitor for success. It can be rocket fuel. But you have to slow down once in awhile and do maintenance on your rocket, or you’ll never re-enter orbit successfully.
				</p>
				<p class="h-l">
					H.L.  Or you will explode or implode I guess.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes, the Dutch call it something like: You have to empty your backpack. I like that. I like the way they say it.
				</p>
				<p class="h-l">
					H.L. You miss your children very much I can tell.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Every single minute.
				</p>
				<p class="h-l">
					H.L. I’m sorry. So I had this segue planned, to brings us into the Clintons, yet somehow we are already there, so I will take that as a good sign. Things seem to be flowing naturally.
				</p>
				<p>
					<span class="douglas">Douglas:</span> I agree. It seems so at least.
				</p>
				<p class="h-l">
					H.L. So now you wanted to go behind the scenes to the root of the cover-up many years back and take a look at our two primary players, the author of this cover-up and international conspiracy. Correct?
				</p>
				<p>
					<span class="douglas">Douglas:</span> Our love story starts now.
				</p>
				<p class="h-l">
					H.L.  Yes, the Belle of the Ball; let’s peel back the facade and do what you do best.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Thanks.
				</p>
				<p class="h-l">
					H.L. Ready?
				</p>
				<p>
					<span class="douglas">Douglas:</span> Absolutely, they are the show, the rest of us are just supporting members of the cast.
				</p>
				<p class="h-l">
					H.L. Okay so let’s talk about The Bill and Hillary Show then.
				</p>
				<p>
					<span class="douglas">Douglas:</span> I think so, let’s give Barack Obama a break, he will need to rest in order to face what is ahead the rest of the week.
				</p>
				<p class="h-l">
					H.L. Yes, I can see that coming.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Bill and Hillary Clinton now there is a pair. He hates women and she hates the Democratic Party, yet neither one of them know it.
				</p>
				<p class="h-l">
					H.L. You know you said that before we started. Do you really think she hates the Democratic Party? She has spent her life in it?
				</p>
				<p>
					<span class="douglas">Douglas:</span> She has spent her life destroying it with her husband. They make a good pair. People this successful don’t do anything randomly; there is always a deep rooted psychological motive. This is what I am an expert at uncovering, and I will get to it in a minute.
				</p>
				<p class="h-l">
					H.L. But first?
				</p>
				<p>
					<span class="douglas">Douglas:</span> First, I want to talk about the love story, their rhythm. While they may not be Johnny and June, you have to admit their resume is quite impressive.
				</p>
				<p class="h-l">
					H.L. Very Impressive.
				</p>
				<p>
				<span class="douglas">Douglas:</span> It all starts with their daily rhythm. For Hillary it is all about Bill; everything! She is a greyhound chasing a mechanical rabbit around the track; she will never catch him. And when she gets close to catching him, she backs off and continues to chase.
				<span class="break"></span>
				She gets up in the morning, goes out conquers the world, and destroys anything that makes Bill unhappy; she destroys anything that gets in her way, returns to Bill. He gives her the prescribed nightly dose of rejection; tomorrow she will repeat the cycle. Tomorrow she will chase again.
				</p>
				<p class="h-l">
					H.L. I think you’re onto something, continue.
				</p>
				<p>
					<span class="douglas">Douglas:</span> She is simply a robot, a highly organized elimination machine, focused on those goals.
				</p>
				<p class="h-l">
					H.L. A cyborg!
				</p>
				<p>
					<span class="douglas">Douglas:</span>  Something along those lines.
				</p>
				<p class="h-l">
					H.L. You know I have always wondered why she stays with him. He doesn’t love her. It’s not like tomorrow he is going to wake up and say, “I am sorry, I love you!"
				</p>
				<p>
					<span class="douglas">Douglas:</span> That is so accurate. I used to wonder as well, I think the entire world does.
				</p>
				<p class="h-l">
					H.L. And you promised to reveal it.
				</p>
				<p>
				<span class="douglas">Douglas:</span> I did. You see, getting stuck in her male issues is a lot less painful than to deal with her real issues; her mother.
				<span class="break"></span>
				As long as she continues to chase Bill, she doesn’t have to slow down. She can catch him anytime she wants. But she doesn’t want too. She doesn’t want to see him that way, the way he really is, which is pathetic.
				</p>
				<p class="h-l">
					H.L. But she is a feminist, don’t most feminists have issues with their father. That’s my observation at least.
				</p>
				<p>
				<span class="douglas">Douglas:</span> It is a good one; in fact it’s a great one. Better you to say it then me. But in most cases it is absolutely correct.
				<span class="break"></span>
				Hillary Clinton is not an authentic feminist however. You can see the difference, but you have to look close. She had too good a relationship with her father. He was her rock. Her mother, like Bill’s, was a monster, though much more subtly. Still, she inflicted a great deal of damage on Hillary.
				</p>
				<p class="h-l">
					H.L. So Bill and Hillary have a lot in common.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes, they do. They both secretly hate women and want to see them demeaned. This is their rocket fuel, their underlying psychotic motivation. This is why Hillary Clinton has been cruel historically to the women who Bill Clinton has had affairs with. It is not that she is uncaring; it’s that they are women. She hates women. He hates women. It is a match made in heaven or hell. Take your pick.
				</p>
				<p class="h-l">
					H.L. That’s amazing. That’s so true.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Sure, it’s not uncommon for children who grow up in abusive households to blame the more sympathetic parent for exposing them to the more damaging one. They often never realize the underlying motivation for their actions. She thinks her issues are with her father, but they are really with her mother. Look at her lately; she always has a female aid with her, like a wet nurse.
				<span class="break"></span>
				When she graduated college, it was her father who made the trip out there to see her. He loved her deeply. He was obviously very proud of her.
				<span class="break"></span>
				It is also why she hates the Democratic Party. Before she was born or when she was little, I forget which, her father ran for office in the Chicago area. He was defeated by a Democrat. Many say he never recovered from that loss, he wasn’t the same.
				</p>
				<p class="h-l">
				H. L. Wow, this makes a lot of sense. So Hillary avenges him?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Absolutely. It’s not unusual for a male to avenge his father; the president who goes to war to destroy a leader who had embarrassed his father. As men it is who we are; it is what so often drives us to the finish line. I likely, subconsciously, avenged my father’s failures. It’s what we do as men.
				<span class="break"></span>
				Now perhaps other women have done it too throughout history, I have not studied them. None come to mind however. Hillary is unique. She is special in this regard.
				</p>
				<p class="h-l">
					H.L She is the Belle of the Ball.
				</p>
				<p>
					<span class="douglas">Douglas:</span> You really like that don’t you?
				</p>
				<p class="h-l">
					H.L. Yes, it sticks. It just seems to fit her; especially now, after you explained it all. I can see her in this great Southern Ballroom. I can see her there: Daddy’s Girl, with all the eyes upon her. It makes sense.
				</p>
				<p>
					<span class="douglas">Douglas:</span> It does, though she is from Illinois. She can steal, rob and pillage the Democratic Party. It is a free pass, this underlying need to avenge her father, to do that.
				</p>
				<p class="h-l">
					H.L. It fulfills her psychological needs.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes and all eyes were upon her at one time; likely she was the belle of the ball as you say, intellectually at least; until she met Bill Clinton. Then he stole her energy and all eyes were on him.
				</p>
				<p class="h-l">
					H.L. That’s how it works?
				</p>
				<p>
					<span class="douglas">Douglas:</span> That’s exactly how it works. You see Bill Clinton has no real female energy of his own. He is a dullard. He has to capture the energy of another female and take it hostage. Then he has the charisma. He does this by cheating. And this is exhaustive, as it takes most of his time.
				</p>
				<p class="h-l">
					H.L. But the prize is monumental, he get’s Hillary’s love and energy.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Now you are getting it. To watch a woman like Hillary with that much talent and ambition inside of her accomplishing important or even silly things for him restores much of the emptiness inside of him. She restores the love his mother took away, or more appropriately, never gave him. Milking that need out of Hillary is the nectar of the Gods for Bill Clinton.
				</p>
				<p class="h-l">
					H.L. And she keeps chasing him.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Sure she does. What else is she going to do? Lie down on the carpet and cry for her mother’s love? That’s what she needs to do. A lot of people would have been better off if she did that. But she lacks the courage or knowledge to do this, to make any real advancement towards healing or understanding her pain.
				</p>
				<p class="h-l">
					H.L. Therefore, we get this monster.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Now there is something you need to know about this equation. And it really is to what extent Bill Clinton has to go in order to keep Hillary. She is very high maintenance for him, because she has a large amount of male energy; because she is so out of his league. He constantly must cheat.
				<span class="break"></span>
				I am guessing it matters who he cheats with too. I imagine at first he was very non-discriminative about who he cheated with. He was sloppy. But over the years he has learned to pick women who dig at Hillary’s craw to get the maximum effect. In other words he likely through trial and error, picks women who have a large amount of female energy. Since Hillary does not, it would bother her more.
				</p>
				<p class="h-l">
					H.L. That’s deep.
				</p>
				<p>
					<span class="douglas">Douglas:</span> You have to realize that when you see the Bill Clinton of late; the one walking around with a soft voice and looks unsteady on his feet. Well, some of that is a health issue, but the fact that he does not radiate any charisma is because Hillary is not propping him up anymore.
				</p>
				<p class="h-l">
					H.L. That is so true, because there are many people with health issues who have plenty of charisma. He is still trying to make her jealous, still cheating I imagine.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Sure. He has too. But the results are not there the way they once were. He is still, or at least was, down in his Presidential Library in Little Rock trying to seduce workers to come up and give him backrubs.
				</p>
				<p class="h-l">
					H.L. I don’t think Hillary cares anymore, do you?
				</p>
				<p>
				<span class="douglas">Douglas:</span> No, I doubt it. But that doesn’t stop him. He is like a compulsive gambler. If he can find that ‘one woman’ who will upset Hillary, then he can get back on his feet. He is sick.
				<span class="break"></span>
				He sits down there surrounded by his props of previous victories, like some old hermit in his castle dusting off trophies. He is simply invisible without his props, without his Hillary of the past.
				</p>
				<p class="h-l">
					H.L. But there’s always tomorrow!
				</p>
				<p>
					<span class="douglas">Douglas:</span> That’s funny. There’s always tomorrow! The human spirit marches on.
				</p>
				<p class="h-l">
					H.L Yes, it does. Earlier or maybe yesterday, you spoke of ‘earning knowledge’. It seems as though when you talk about this you have indeed earned it. Is that true?
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes, unfortunately I have earned this knowledge the hard way. You see I have had no less than seven or eight Hillary Clintons in my life.
				Do you think that I, on my own, would ever have the brilliance and energy to make the largest discovery in human psychology? If you believe that, then I truly pity you. Without those amazing women, I would still be crawling around on my belly in the same condition as when they found me. I owe these women almost everything.
				<span class="break"></span>
				I told you before we began this, there are no heroes in this story. There is only an assortment of wounded characters with different degrees of damage. Do you remember?
				</p>
				<p class="h-l">
					H.L. Yes.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Now with that said, there is a large difference between me and the Clintons. I have spent the last 25 years of my life working my fingers to the bone to get better. They in contrast have spent the last 25 years indulging and feasting on the souls of others, while ignoring the very pain that defines them. If I have any advantage, it is this.
				<span class="break"></span>
				The energy I have now is my own, earned by me. I take no hostages. I keep no prisoners. That is my greatest personal accomplishment, If not my only one. But it was not always that way. I was not always that way.
				</p>
				<p class="h-l">
					H.L. Do you want to talk about that now?
				</p>
				<p>
					<span class="douglas">Douglas:</span> I definitely think it is important to be honest. I do think we should briefly cover it. How about at the end of the day? We still have a large amount of ground to cover.
				</p>
				<p class="h-l">
					H.L. So why do think Bill Clinton would want to suppress The Theorem?
				</p>
				<p>
					<span class="douglas">Douglas:</span> Well there are two reasons at least. One is easy, the other we will have to work at to define.
				</p>
				<p class="h-l">
					H.L. Go ahead.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Okay. Well have you ever heard of the Baby Butcher of Hope Springs? Or better yet; don’t answer that!
				<span class="break"></span>
				Do you remember the time when the mob of Christian Citizens of Little Rock lined up outside the Clinton Presidential Library and demanded he come out and face justice?
				<p class="h-l">
				H.L  No of course not. It’s never happened.
				<span class="break"></span>
				Of course I am cheating here a little bit; as you already told me it was his veto of the ‘partial birth abortion ban’ that is fueling those fears.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Twice. He vetoed that bill twice.
				</p>
				<p class="h-l">
					H.L. I could see the concern. That isn’t even really an abortion. Even the most indoctrinated pro-choice supporter had a hard time with that one. The fetus is partially delivered, then killed, and the dead fetus is delivered. Why would he veto that? Why would he want that to occur?
				</p>
				<p>
					<span class="douglas">Douglas:</span> Well, this is the second part of the answer. But first, it is important to reflect on what The Theorem discovers and defines.
				</p>
				<p class="h-l">
					H.L. I have read it, I know. By the end of the pregnancy or even late into the pregnancy the fetus would meet any definition of consciousness. For God’s Sake it is accomplishing planned movements!
				</p>
				<p>
					<span class="douglas">Douglas:</span> So it’s just bad luck for him that the origin of the answers are all found in the womb, the origin of our behaviors; as the fetus is subject to a fear conditioning model and from there on, well, things get really exciting.
				</p>
				<p class="h-l">
				H.L. Well it’s bad luck for him that The Theorem came out after he was president. It’s his bad luck that he vetoed that bill. It’s his own fault, he had no common sense.
				<span class="break"></span>
				Certainly if he would have known, he wouldn’t have done that.
				</p>
				<p>
					<span class="douglas">Douglas:</span> There, I may disagree with you. Earlier when I said Bill Clinton had known me since 1995.
				</p>
				<p class="h-l">
					H.L. I caught it; I figured you would explain it later.
				</p>
				<p>
					<span class="douglas">Douglas:</span> It is just that yesterday when I said I waited 10 years to write the final draft of The Theorem, as I was submerged in doubts. Well most of that is true. And for all practical purposes I did wait. But in 1995, I did send out a completed manuscript called: <span class="italic">A Theorem of Natural Conspiracy</span>.
				</p>
				<p class="h-l">
					H.L. Sounds like a detective novel.
				</p>
				<p>
				<span class="douglas">Douglas:</span> I agree; it wasn’t very good. It was not well written. I sabotaged it as well. At the last minute I put some story about sparrows in there. It was a mess. I was a mess. But still I sent out three copies to three New York publishers. Yet, even with all its failings; and it had many, the basic model was in there, at least a large part of it was.
				<span class="break"></span>
				Again, it was in no way in any condition to be published. But I did get some very positive personal responses from publishers. I received one strange one as well. Anyways, it is possible.
				</p>
				<p class="h-l">
					H.L. So when you say you had the basic model in there. You had the two fetal development cycles and so forth, and all the disorders. Or did you have that much then?
				</p>
				<p>
					<span class="douglas">Douglas:</span> I did. It was substantial what I delivered. You know there was nothing like it  back then and  certainly there is nothing like it now. I could easily see how a publisher would have passed that around; especially, when you have a pro-choice president with extensive media connections, like Bill Clinton. It would be something he would want to know about. You know, the world was a lot smaller back then in 1995. It seemed that way at least.
				</p>
				<p class="h-l">
				H.L. Yes it did. That’s just crazy. But I mean crazy in a bizarre way. Honestly this makes everything come together. I definitely think that may have happened.
				<span class="break"></span>
				So he is sitting there stewing for what, 8 years?  He is wondering if you’re ever going to get your life together to get this book out.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Then suddenly in 2006 there it is; his worst nightmare. His legacy would be toast. This was his fear; he would be erased out of the history books. So he builds this big foundation to line his pockets with cash. But he sells the fear of The Theorem to his gullible donors and contributors right?
				<span class="break"></span>
				He tells them they are all going to be in trouble. He lies, of course. He sells it to the party faithful as the death of the Democratic Party. And since he is the former president everyone listens to him. No one questions.
				<span class="break"></span>
				Somewhere along the line it becomes personal, it becomes his quest. It’s a way he can touch something larger than him, without getting hurt or rejected. He will reject the work first, me first, by suppressing the discovery.
				</p>
				<p class="h-l">
					H.L. I don’t care how you notice me, just as long as you notice me?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Sure. This is common with abused children. He is probably my biggest fan; he is always on my website. He just is so afraid to get hurt. He just wants me to notice him, like you say. He just wants to be a part of the parade, even if he’s the guy who stands in the middle and blocks the floats from coming down their assigned route.
				<span class="break"></span>
				He just wants to be involved.
				</p>
				<p class="h-l">
					H.L. Well, I don’t think you are too far off there. That narrative makes sense to me.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes and it’s a sad narrative. To be forgotten reminds him of his mother ignoring him, being stuck at his grandparents. To be abandoned. These are big pains, some of the biggest we experience.
				<span class="break"></span>
				He creates the chaos, and Hillary enforces it. These people are not well.
				</p>
				<p class="h-l">
					H.L. They need to get out of the way.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Well, it’s a little late for that now. But you’re right they do.
				</p>
				<p class="h-l">
					H.L. You said there were two reasons. What is the other?
				</p>
				<p>
				<span class="douglas">Douglas:</span> This one is going to take some time. I doubt anyone would publish this, as we have to go very far off subject to get back on it. It gets to the heart of humanity, the core of what it means to be a man; to be a woman.
				<span class="break"></span>
				It’s quite intense. Some of it is from <span class="italic">The Legacy Letter</span>, scratches of it at least.
				</p>
				<p class="h-l">
				H.L. I’m intrigued. Now I have to hear it!
				<span class="break"></span>
				You should have just said there was one reason. It’s early, we have time, we are moving fast enough. We are going to have to edit this, so keep going. If it’s too long I will condense it.
				</p>
				<p>
					<span class="douglas">Douglas:</span> You can’t condense this. This is something you can’t condense, but whatever.
				<span class="break"></span>
				As I told you it is exhausting to be Bill Clinton. It is very tiring to have half your energy in the past, buried in the grave with your mother. You see every perception and every emotion has to be filtered though that trauma he experienced; then he needs to pull it up out of his subconscious and formulate an action out of those motivations. And truthfully most of his actions are not very positive. So then he has to deal with the implications of those actions. That in itself is tiring.
				<span class="break"></span>
				Now add Hillary to the picture. While she nullifies some of that noise by his suppression of her spirit, as you have seen, she herself takes work and maintenance as well; and therefore energy.
				</p>
				<p class="h-l">
					H.L. Sounds exhausting, I’m tired just listening to it.
				</p>
				<p>
					<span class="douglas">Douglas:</span> So he is always looking for bargains. He is always looking for things that can yield him two for the price of one. He is tired.
				</p>
				<p class="h-l">
					H.L. Kind of like cheating; he gets two for one. He enjoys his sexual escapades and the rewards; meanwhile he keeps his wife chasing him.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes, it is just like that. He wants a bargain. But he has a need to fill. He wants to symbolically punish his mother. She destroyed him. She stole, as many abusive parents do, what was not hers to take.
				She took the energy that was his and gave it to her husband or she attends nursing school with it or whatever. He feels cheated. The only way to make that right in his mind is to see women humiliated, the way he once was as a child.
				<span class="break"></span>
				He does that by cheating and by watching women humiliate themselves by demoralizing themselves. Now there are few things more demoralizing for a woman than an abortion.
				</p>
				<p class="h-l">
					H.L. I don’t know if I would agree with that. But go ahead, this is interesting.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Good. Now things are going to go very deep, very quickly here. We are in new territory of human perception. So you will have to pay close attention. At the same time, if you get lost, please by all means, speak up.
				</p>
				<p class="h-l">
					H.L. Don’t worry I will.
				</p>
				<p>
					<span class="douglas">Douglas:</span>  As men, many of us want to leave something behind. I am not speaking of just children either.
				<span class="break"></span>
				Many of us, especially the most damaged, want to be remembered for something. Now it may be as simple as a building with our name on it. It may be the construction of a nice house that will withstand the ‘test of time’. Or it may be more complex. Maybe we want to start a company that will outlive us, or a foundation or charity with our name attached to it; something that will go on long after we are gone.
				<span class="break"></span>
				We want something, beyond a tombstone, which says, “I was here, I conquered. All this pain and hard work meant something!”
				</p>
				<p class="h-l">
					H.L. Sure. I think this feeling is a common trait in many men. I already realized some of this after I read <span class="italic">The Legacy Letter</span>, but for the sake of the interview I will go along as though I haven’t read it.
				</p>
				<p>
					<span class="douglas">Douglas:</span> That’s good, because this is going to launch where that letter left off, so you will have an advantage.
				<span class="break"></span>
				Other men are more artistic. They may want to write that song or a catalogue of songs forever remembered. Maybe they want to paint that painting that will someday hang in the Louvre. They may want to write a classic novel. The list goes on and on.
				<span class="break"></span>
				They want to leave something behind to be remembered by. This is the quest for immortality, and for some men it is a massive obsession. For example, Antoni Gaudi of Spain; he left behind some amazing works, incredible buildings which will likely be remembered forever. But his devotion to immortality was complete. He never married; he just worked on leaving a legacy. His quest for immortality was immense, and it paid off.
				</p>
				<p class="h-l">
					H.L. Don’t forget Beethoven! His commitment was complete.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes, now women share this as well. There are great artists that are females, and many of them. However for most women it is different. Because while they share that quest and thirst to be remembered and will sacrifice devoutly to obtain it, once they have a child everything changes.
				</p>
				<p class="h-l">
					H.L. Because the child quenches that thirst for immortality, as this child will have another. And that child will have another. And so on.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes, but you’re cheating. You’re stealing my moment because you already read <span class="italic">The Legacy Letter</span>.
				</p>
				<p class="h-l">
					H.L. Oh, okay sorry.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Of course, I am kidding, I appreciate your input; very much so.
				</p>
				<p class="h-l">
					H.L. Continue.
				</p>
				<p>
					<span class="douglas">Douglas:</span> So yes, once a woman has a child her priorities change. Some women get it quicker than others; these women figure out the entire equation right away.
				<span class="break"></span>
				The child is everything. As you are probably aware this can change the dynamic of the relationship between her and her partner, especially if that partner is a man.
				<span class="break"></span>
				The little bundle of joy is not just her child, but her legacy; her immortality. Now while mother and father may love the child the same amount, a mother’s love is different. Because she witnessed the entire cycle of birth from within her; she is primary witness to this immortality making machine that is called her womb. While obviously both play a part, she experiences physical components of her body detach and grow into an independent being, her child.
				</p>
				<p class="h-l">
					H.L. So when a mother loses a child, when her child dies she not only loses her child, but also the loss of her great painting? She loses her Rembrandt, a piece of her immortality as well?
				</p>
				<p>
					<span class="douglas">Douglas:</span> Exactly, but it is more than that even, because there is the biological element we may or may not get into later. But you’re right. There is the loss of that child and the entire emotional blow that goes along with it, the one experienced by both parents. But there is that other loss, the intangible one; the immortality that child promised, her work that would stand the test of time.
				</p>
				<p class="h-l">
					H.L. When you explain it like that it really makes sense. She experiences it more directly on a physical level.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Of course fathers play a role, an important role. Beyond the biology, there is the craft of the father. Perhaps the primary theme of his importance can be witnessed in this interview. But he definitely has a role.
				<span class="break"></span>
				Now a woman, rich with the knowledge that she is Nature’s chosen gender; Nature’s Queen essentially, is very generous with the trappings of her immortality. To keep household peace and to make sure the man feels involved, she gives him a consolation prize. She allows the child to carry his last name or surname. As guys this is all we get. But it means a lot to us.
				</p>
				<p class="h-l">
					H.L. This is great, keep going. I will fight to include this.
				</p>
				<p>
				<span class="douglas">Douglas:</span> As I said earlier; many women don’t need to be told about this. They feel it right away. They feel it in a way that men never can.
				<span class="break"></span>
				For other mothers however, it may take awhile. They may be a little slower to get the entire immortality scenario. Now this can be for a myriad of reasons. They may have low self-esteem. They may believe they are toxic, and therefore they falsely assume that anything that comes out of them cannot be of value. This could be from their childhood. Or they could be with a man who is holding down their self-belief. The second reason unfortunately is quite common. One thing is for sure however; by the time they are a grandmother, most all of them get it.
				<span class="break"></span>
				You see a grandmother can see the entire equation fold out in front of her. She sees two generations, birthed right out of her womb. This is an amazing realization. It really is. In fact many would say that there is truly no other love like the love of a grandmother for her grandchild; for this is a love on multiple levels. After all, who is not going to fall in love with a baby, especially if it’s from your child?
				<span class="break"></span>
				But there is that other level of love privileged only to her. For when she holds that baby she has the belief that this baby one day will have another and this will go on forever; ad infinitum.
				</p>
				<p class="h-l">
					H.L. This is true, my grandmother was amazing.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Just go to any airport, bus station or train terminal and grandmothers are there. They will tell you they are on their way to see their daughter or son, to help out with that new baby; however make no mistake, this is not their primary motivation.
				<span class="break"></span>
				That’s right. Their real motivation is to get their hands on that grandchild. Oh, they will pitch in to work; they will work their fingers to the bone to make sure that child has everything it needs. It is comparable to Michelangelo enduring tremendous physical pain to paint the Sistine Chapel. I guarantee you the motivation is the exact same.
				<span class="break"></span>
				Every time she holds that child in her hand, it is Leonardo da Vinci holding his Mona Lisa. This is her immortality. This is her statement that all the pain is worth something.
				</p>
				<p class="h-l">
					H.L. That is so true. It’s like you are describing my mother in-law to the letter. I remember when our daughter was born, my wife’s mother stayed for almost three months. My father in-law had to finally drive 1200 miles to come get her. I don’t think she would ever have left. This is so accurate.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Thanks, and we will circle back to abortion. We are almost there.
				<span class="break"></span>
				As I also stated earlier, when a woman has a baby; when she has your child, she changes. Now these are subtle changes, and a healthy couple barely will notice them. But let’s be honest, there are a lot of unhealthy couples out there.
				<span class="break"></span>
				Even the best of relationships however can be subject to changes and strains. The dynamics are changing. The woman’s self-esteem, while she may be vulnerable during pregnancy, is changing. She subconsciously realizes that she is the chosen gender. While her boyfriend or husband may still hold her self-esteem in his hands, he will never again have all of it. Those days are over. She is the life giver, and he is the co-pilot on this journey.
				<span class="break"></span>
				There are also subtle subconscious changes a man realizes. Here you have to pay close attention, because if you don’t you can easily miss them.
				<span class="break"></span>
				But often times, a man is somewhat intimidated by the process of a woman having a child. Typically he is not even consciously aware of this intimidation. But it’s there. He may cheat on her; to subordinate her spirit, her independence and self-esteem. This is not that uncommon. Many women falsely believe that this is because she is unattractive temporarily while pregnant or some other reason. This couldn’t be further from the truth of his real motivation.
				<span class="break"></span>
				Or he may treat her badly; he may leave her or even in worst cases he may physically hurt her. In many ways pregnancy can be a dangerous time for a woman.
				<span class="break"></span>
				You see a woman’s role is changing, in so many ways. She, instead of supporting his quest for immortality, is now actually becoming a competitor for it. This small fact is a very big deal.
				<span class="break"></span>
				Sometimes this will not even occur to the man with the first child, instead this subtle competition will lay dormant until the second child is born, and then it will arise.
				</p>
				<p class="h-l">
					H.L. This is true.
				</p>
				<p>
				<span class="douglas">Douglas:</span>: But even in the healthiest of relationships he will likely be moved to address his own immortality, as hers is blooming in front of him.
				<span class="break"></span>
				Now sometimes this reawakening of his quest for immortality can be subtle. He may take chances he would not normally take to get ahead. If he is a businessman, he may aggressively expand his business. His pregnant wife smiles, as she tells herself that he is really going ‘all in’ for this child. But be assured his motivation is not that, it is different.
				<span class="break"></span>
				He may undertake the construction of that new house, becoming obsessed with the details. If he is an artist, he may get very serious about his art. He may realize it is now or never, but mark my word ‘never’ will not ever come; for he is in direct competition to her immortality.
				<span class="break"></span>
				This can, and has often been, a departure point for many couples. After all she has supported his ambitions, his quest for immortality since the beginning. Now it’s her turn and she needs his direct attention and focus on her immortality: this child. Yet there he is out in his workroom, painting a portrait trying to be Picasso. There he is overseas expanding his business trying to be J. Paul Getty. There he is running for office trying to be John Kennedy. The list goes on and on. Are you following me?
				</p>
				<p class="h-l">
					H.L. Yes, brilliant. I have seen this more times that I can even count. The dynamics change. They really do.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, it is there. There is subtle subconscious envy by the man towards the woman. Now I am not talking about womb envy. No man that I know wants to have a baby, as it looks miserable. But again the dynamics of the relationship change and there is a competition for immortality. Though, it is a competition a man will never win. As what comes naturally to her, will have to be worked for tirelessly by him.
				<span class="break"></span>
				Still no matter, as whatever he accomplishes, it will never compare to the process of birth itself. Even Debby DoNothing from Nowheresville, USA; dropping a kid out of her womb like a bowel movement is more valuable than an Einstein or a Bach.
				</p>
				<p class="h-l">
					H.L. Because Debby DoNothing’s kid may go on to birth five Bach’s and Einstein’s?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Exactly. But this is very hard for man to accept. He will spend his life, in many ways trying to subconsciously negate that statement.
				<span class="break"></span>
				You have to realize that not only did we experience our development encapsulated within a woman, within her womb, but also that some of that development was not pleasant. Indeed much of our development was very painful. This becomes oppressive for the young male.
				<span class="break"></span>
				Now, after birth, as a male, we are again controlled by a woman; we are controlled by our mother. While it is a loving control, and nurturing control, it is still control nonetheless. We are forced as males to quickly realize this immortality that she wields.
				<span class="break"></span>
				This is why as a male we look to our father. After all, dad has dealt with this inequity between genders longer than we have. He knows how to cope.
				</p>
				<p class="h-l">
					H.L. But if dad’s not there?
				</p>
				<p>
					<span class="douglas">Douglas:</span> But if dad is not there or the mother is abusive, then her power; this immortality creating force that she contains, is magnified. It multiplies and is overwhelming for the male. Therefore when this boy sees a girl; this man sees a woman, he is not seeing her the way she really is. He is seeing her much larger than she really is.
				<span class="break"></span>
				The only way to offset this perception is for him to suppress her, or suppress a symbol of her; female for his mother. He needs to bring her down to his level. Now there are lots of ways he can do this, from emotional to physical abuse, and various techniques of manipulation.
				<span class="break"></span>
				The entire goal is nothing sinister, it is survival. Without him suppressing her he cannot concentrate; and without the ability to concentrate, survival is an almost impossible struggle. Indeed while the motive may not be sinister; the outcome, this destruction of women, is very damaging. It is perhaps one of the worst sins in the world.
				</p>
				<p class="h-l">
					H.L. Okay, I think I see where you are going with this. The sickest individuals see the female as direct competition, instead of having a parallel interest.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, thank you. That is very helpful.
				<span class="break"></span>
				He sees not only her as competition, but specifically the process of birth itself. And it is in a way very intimidating.
				<span class="break"></span>
				You know nothing man can ever do will match the process of birth itself: nothing. Going to the Moon, or Mars or wherever is nothing compared to the ability to create a child from your womb. Like I said earlier, he will always try. He will never give up. While this inadequacy of the male has been responsible for some of the greatest achievements in mankinds’ brief tenure, it has also been the cause of a large amount of discord between the genders; the sexes, between man and woman.
				<span class="break"></span>
				It has been going on for thousands of years, this subconscious battle, and it will go on for another thousand. Man is in second always.
				</p>
				<p class="h-l">
					H.L. I see it.
				</p>
				<p>
					<span class="douglas">Douglas:</span> So being a man, what if I show you a way to even the odds?
				</p>
				<p class="h-l">
					H.L. What?
				</p>
				<p>
					<span class="douglas">Douglas:</span> Now if you are healthy, you would think that is ridiculous.  By your reaction, I think it is obvious that you do.
				</p>
				<p class="h-l">
					H.L Yes, I agree.
				</p>
				<p>
					<span class="douglas">Douglas:</span> But what if that person you are talking to is a Bill Clinton. What if that person were severely abused by a female; by his mother? Remember, to him a female is an overwhelming power. She earned that right over him by the abuse she subjected him to. So suddenly he is interested!
				</p>
				<p class="h-l">
					H.L. But you can’t prevent a female from having a child.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Okay, but what if I can devalue that process?
				<span class="break"></span>
				What if I can degrade the single elevation she has over me?
				<span class="break"></span>
				Then it may be easier to live in a society where the female is so highly elevated by Nature. It is easier to deal with my insecurities and the memory of that overwhelming force; my mother, who deserted me for nursing school, dumped me at my grandparents and in her weakness allowed an abusive stepfather to beat the living hell out of me in our house.
				</p>
				<p class="h-l">
					H.L. I see.
				</p>
				<p>
				<span class="douglas">Douglas:</span> What if I can convince a woman that the prize she is carrying has no value? Then I can better live in that society.
				<span class="break"></span>
				Or even better what if I can convince her it is an inconvenience, a tumor she can easily remove in an office? Now I can live in that society that is oppressive to me.
				<span class="break"></span>
				What if I can detach her from her natural instincts, and put her to work and make her compete against me at something I am good at? Like a career or a job.
				<span class="break"></span>
				You see, I want to keep her imbalanced and off-center. This is my goal. I don’t want her to know she is dominating me; I want to make her play on my home court.
				</p>
				<p class="h-l">
					H.L. Hillary as well. Like you said, she has serious issues with her mother. She has a vested interest in seeing women humiliating themselves, treating this elevating gift as a cancer to be easily removed.
				</p>
				<p>
					<span class="douglas">Douglas:</span> That is so observant. They are a perfect couple, as both want and need to see women humiliated. This reduces the influence of that childhood trauma their mother inflicted upon them, and therefore makes it easier to concentrate.
				</p>
				<p class="h-l">
					H.L. So they are essentially acting out their hatred towards their mother instead of dealing with it. With abortion as the ultimate humiliation to other women, this symbolically is a strike against their mothers. That is awful.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Well you are close. Abortion is just essentially a medical procedure, though degrading.  The way to truly see a woman suppressed is get her to humiliate herself by convincing her she should fight for that right to humiliate herself.
				</p>
				<p class="h-l">
					H.L. I see. So it’s not about the abortion itself. It’s about convincing her she is inferior and what she contains inside of her is of no value. These twisted folks want to see women march for the right to humiliate themselves.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, exactly. They know the truth. The Clintons are aware of this female elevation over men in regards to immortality more than most of us. Remember they witnessed it as a child by that abusive mother.
				<span class="break"></span>
				But to change that narrative is powerful, to change that memory is the ultimate goal; to essentially go back and nullify what happened to them in their subconscious. This is what occurs when they utter the word ‘abortion’. They want to deceive the masses the way their mother deceived them. They get energy from that.
				</p>
				<p class="h-l">
					H.L. But how do they accomplish that?
				</p>
				<p>
				<span class="douglas">Douglas:</span> How do we accomplish this as a society? Well we will have to use some trickery. Let me give you an example:
				<span class="break"></span>
				Let’s say I am the second fastest runner in the world. I live in New York. The fastest runner in the world lives in Oregon. His name is Jed. Now, no matter what I do, I can’t beat him.  I have raced Jed for years, he is naturally gifted. He is super fast! He is a superior athlete to me. I know in my heart I will never be victorious over him in a race. It is just not going to be. Now before too long my career will be over, and so will Jed’s, as we have both been at this for awhile. The Olympics are coming up soon; it will be our final race together. I would love to retire as number one!
				<span class="break"></span>
				If I have any advantage over Jed, it’s this: Jed is not very bright. While he was given a physical advantage, a mental advantage for him was not in the cards. In short, he is stupid. So I hatch a plan to defeat him. I have been dealing with a broken toe for some time now, and Jed knows it. I have had surgery, but it is still not better. So when I see Jed on the practice track, I tell him I want to cut my toe off but the Olympic Committee will not let me.
				<span class="break"></span>
				While confused, Jed is sympathetic, as he always admired my intelligence. I rant about the Olympic Committee. I tell Jed they have no right to tell me what to do with my toe. Jed is all in on this. He tells me anything he can do to help, let him know. Well, I tell Jed that actually I have hatched a plan to rebel against those oppressive bureaucrats. Just before the morning of the race, I am going to cut my toe off, and run the race with nine toes in protest. I ask if he will help me and support me by doing the same. Jed agrees. He says at very least he will consider it. Again, Jed is not very bright.
				<span class="break"></span>
				So on the morning of the race of the Olympics I am ready. I look over and I see Jed over there. His foot is all bandaged up and he is ready for the race. To his surprise, there are no bandages on my foot. For unlike Jed I have not cut my toe off. I win the race. For once, I am number one; I am the gold medal winner!
				<span class="break"></span>
				Now every time I feel bad about myself, all I have to do is to go home and watch that tape of Jed limping around the track in humiliation. I have tricked him into a disadvantage. Instead of playing his game of physical domination, I have made him play my game of mental domination.
				</p>
				<p class="h-l">
					H.L. That is so true. So essentially in the race for immortality, the quest to be remembered, woman is physically superior but mentally inferior. Is that what you are saying?
				</p>
				<p>
				<span class="douglas">Douglas:</span> No, no, no. Don’t put that on me. Women are equal to men in intellect. However, pain and need; hence low self-esteem can make women stupid, just like it can for men.
				</p>
				<p class="h-l">
				H.L.  Good, because not all women would fall for this, and are easily tricked.
				<span class="break"></span>
				Many women, the ones I know now, would just as soon cut your throat rather than allow you to cut into their womb.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Very good point. The goal is to find the ones who are vulnerable, for they are easier to trick. This is getting harder than it used to be.
				</p>
				<p class="h-l">
				H.L. What do you mean by that?
				<span class="break"></span>
				Wait I wanted to add something to what you said, I just realized.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Go ahead.
				</p>
				<p class="h-l">
				H.L. Years ago I knew a few women who had abortions and I think there is something to what you are saying here.
				<span class="break"></span>
				Looking back, it seems like their regrets are that they were fooled or tricked.
				<span class="break"></span>
				They bought into someone else’s agenda at the time. Maybe it was their parents that wanted them to finish school, or whatever. But it wasn’t what they wanted, as they really wanted to have the child.
				<span class="break"></span>
				It was as if those they trusted took advantage of them at their most vulnerable time. The primary reaction when they express it is that feeling they were duped, along with the obvious sorrow. But I have seen that look of being tricked on their face.
				</p>
				<p>
				<span class="douglas">Douglas:</span> I have never seen it, but I would definitely believe you. Based on what you said, it’s kind of like they took the ultimate goal away from them, because they weren’t ready for it.
				<span class="break"></span>
				It would be like doing this to a man: Well I took your million dollars away from you when you were 18, and threw it in the garbage. You know you would have just gotten into trouble with it. You were too young. You would have never finished school. It would have impeded your social life. Don’t worry though you will still have another 10; maybe 15 years to make that money up. But if you don’t make it by then, you will never have another dime.
				</p>
				<p class="h-l">
				H.L. That’s so true, it’s ridiculous. If the ultimate personal and subconscious goal for man and woman is the pursuit and attainment of immortality, each accomplishing it in different ways, then who has the right to tell you it is not the proper time for you to experience yours?
				<span class="break"></span>
				That is evil; those who would do that have a hidden agenda to harm you.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, but the sad thing is sometimes those with the hidden agenda are unaware that they have one; they are just mindlessly following the dogma of society’s goals.
				<span class="break"></span>
				Worse yet, they are often the ones closest to the girl in crisis; the girl in trouble, the girl that is pregnant.
				</p>
				<p class="h-l">
					H.L. But here you are incorrect. Because while she is vulnerable she is not in crisis, she is about to experience immortality. There is no crisis in that!
				</p>
				<p>
					<span class="douglas">Douglas:</span> You’re right, thank you for correcting my word choice. In some instances applying the exact words are essential. This is one of those cases.
				</p>
				<p class="h-l">
					H.L. So you were saying it is hard to find women to trick, who are vulnerable. Why is that again?
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes, thank you. Well to get to that we have to do some Theorem 101 review. You read the book so you should get this quickly.
				</p>
				<p class="h-l">
					H.L. I did.
				</p>
				<p>
					<span class="douglas">Douglas:</span> One of the most significant discoveries in The Theorem is the human reproduction model. It is one aspect that I am particularly proud of, as it continues to yield results.
				</p>
				<p class="h-l">
					H.L. Yes, I remember. You show how Nature steals the females’ self–esteem and how then the male is there to replenish it. I remember it well.
				</p>
				<p>
				<span class="douglas">Douglas:</span> That’s it. Though I used the word ‘stripped’.
				<span class="break"></span>
				Keep in mind what I am going to share with you is a synopsis of a complex neurodevelopmental model, so do not assume you or any readers will understand it all from this summary.
				</p>
				<p class="h-l">
					H.L. Got it.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Since male and female both originate from the same female womb, getting the male interested in the female without the exclusive use of pheromones is easy. To get the female interested in the male without pheromones however is difficult, as she has no real biological connection to the male. She didn’t come out of him, so Nature can’t lead a trail back to him, the way she can with the male to female.
				<span class="break"></span>
				Nature accomplishes this attraction to the male by stripping the female of her self-belief; her self-esteem and her sense of worth. This is intended to prevent her from being interested in another female sexually. But as you know Natures' model is fragile, and sometimes fails, as women are often interested in other women. At the same time there are over seven billion people in this world, plenty of evidence, which can attest to the effectiveness of Natures' model. So it works.
				</p>
				<p class="h-l">
					H.L. It definitely works, there are no shortage of people.
				</p>
				<p>
				<span class="douglas">Douglas:</span> The ideal scenario is that the father then, through his support and presence will restore some of that self-esteem and belief in the female, like you said. Then, as she matures her boyfriend or husband will take the fathers' place. From him she will retain the self-esteem her father restored.
				<span class="break"></span>
				One of the ways which Natures’ model can go askew is if the father isn’t there. He is out of the picture. Therefore there is no male to restore the self-esteem of the female. Now historically this has been a problem, as many men have died in battle throughout history; or they have been deployed during wartime or were absent from their daughters life for numerous reasons.
				<span class="break"></span>
				Going back to the 1960’s and 1970’s when the pro-abortion movement really gained steam, including Roe vs. Wade, you had generations upon generations of American men being deployed during wartime. In the 1900’s or what we call the Twentieth Century, we had many wars and conflicts.
				<span class="break"></span>
				So you had many women who grew up without fathers. Also, many fathers that were in their daughter’s life had archaic perceptions of child rearing. They were not close to their daughters. They were often overly strict with them. They were oppressive. From those sociological factors you could pull a nice pool of women with low self-esteem, and not trusting control from a man.
				</p>
				<p class="h-l">
					H.L. The feminists?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes. And with low self-esteem, because their father had been absent or cold-hearted, you could make them buy into someone else’s agenda.
				<span class="break"></span>
				But let’s be clear about one thing, a good portion of feminists are not damaged. They are a huge aspect of my readership, and I love them dearly. So we are speaking about a certain percentage of feminists, not all.
				</p>
				<p class="h-l">
					H.L. I just thought of something. Not only are fertile women a threat subconsciously to men, but also to women past the reproduction age.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes good point. They were once Nature’s Queen, but now they have been cast out, thrown aside and tossed away by time itself; demoted to a lowly handmaiden.
				</p>
				<p class="h-l">
					H.L. A pithy, biddy; self-determined to advise her eminence.
				</p>
				<p>
					<span class="douglas">Douglas:</span> So she sees that girl or young woman there, vibrant and in all her glory and her world crumbles; it all seems so unequal.
				<span class="break"></span>
				Now the best way to strike back is to try and help. She advises the girl to be something more, to be strong and confident like her. Of course she is not aware that she is giving her bad advice, she is not aware that she secretly harbors resentments towards her own father; the man who was absent, the man who controlled her.
				<span class="break"></span>
				Or it could be her mother, who is the subconscious protagonist to her motivation. Her mother humiliated her, demeaned her, and now it’s her turn. The important thing to realize is that this all happens on such a subconscious level.
				</p>
				<p class="h-l">
					H.L. Sounds like you just nailed the psyche of a pro-abortion activist.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Sure. Again, the sad part is that she is not even aware of her underlying motivations. What she is doing is dangerous; she is polluting the pond for future generations. Nature rewards those who reproduce; it’s always been that way. To go against that is to go against Nature, to go against God! And that’s never a good idea.
				</p>
				<p class="h-l">
					H.L. It could be something as simple or tragic as she was once advised to get an abortion herself. Then, like you said she strikes back.
				</p>
				<p>
					<span class="douglas">Douglas:</span> That’s a good point, it doesn’t have to be an underlying drive; it can be a surface based motivation. But it’s always there and it’s always foul.
				</p>
				<p class="h-l">
					H.L. This is so true. It is their right to dominance they are marching against.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Today things have changed in relation to the available pool of females with low self-esteem.
				<span class="break"></span>
				Fortunately our leaders and other world leaders have wised up. There are no more major global wars and have not been for quite some time.
				<span class="break"></span>
				Mom is working and father is home more often as well. So you have this entire generation of females who believe in themselves in relation to males and their self-esteem has been replenished; this, as much as anyones can in this day and age. They believe in what is inside of them therefore to be valuable.
				<span class="break"></span>
				They are also suspicious of anyone who wants to take that fetus away from them. Certainly there is no interest in marching in parade to kill what they love; to kill a part of them.
				</p>
				<p class="h-l">
					H.L. Yes, I agree with you there. Don’t you think however with the mothers working, they are growing up with unmet female needs by their mother?
				Don’t you think this is responsible for so many girls being interested in other girls?
				</p>
				<p>
				<span class="douglas">Douglas:</span> That makes sense to me. It is out of the scope of The Theorem, but it certainly seems logical.
				<span class="break"></span>
				So if you are correct, this is interesting. Then I imagine these females could still be fooled and tricked by a strong female leader, if they suffer from these unmet needs due to their mother’s absence; but not to the point of abortion.
				</p>
				<p class="h-l">
					H.L Yes, but with a strong father, or even a father that is there?
				</p>
				<p>
					<span class="douglas">Douglas:</span> The father is the key to her self-esteem. Maybe not all of it, but all aspects related to believing in the value and sanctity of what is inside her, most definitely.
				</p>
				<p class="h-l">
					H.L. So you are saying that the biggest friend to abortion is war, and the greatest foe is peace.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes, and this is the reason abortion numbers are coming down. The father’s presence is only genuine prevention for future abortions. Dad, or at least a positive male role model, has to be there to restore that self-esteem.
				</p>
				<p class="h-l">
					H.L. So if you want to increase the demand for abortion, start a war, wait ten years for these girls to mature, and watch them spin.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Exactly, as tacky as that sounds; unfortunately, you hit it right on the target.
				<span class="break"></span>
				</p>
				<p class="h-l">
				H.L. I think you are obviously correct on this point. But the Democratic Party is still singing that same old tune.
				<span class="break"></span>
				Why don’t they wise up and drop abortion from their platform. Certainly they can find something else to put in its place. They risk extinction if they don’t change with the times.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Well I think you just answered your own question.
				</p>
				<p class="h-l">
					H.L. What do you mean?
				</p>
				<p>
					<span class="douglas">Douglas:</span> Well, I will be more specific. I think they will. They are smart enough to see the trends. But remember Hillary Clinton’s issue?
				</p>
				<p class="h-l">
					H.L. She hates the Democratic Party!
				</p>
				<p>
					<span class="douglas">Douglas:</span> Now one of the best ways to destroy the party is to keep it stuck in past, to not change and grow. She is doing a great job at that. She is a dinosaur.
				</p>
				<p class="h-l">
					H.L. It is sad in a way. She is avenging her father’s defeat by the Democratic Party and she doesn’t even know it. All this damage, all that money and all those lives, just because she did not have the courage or the ability to face her own pain.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Hey, but maybe tomorrow Bill will love her!
				</p>
				<p class="h-l">
				H.L. That’s funny, yeah maybe. I won’t count on it though.
				<span class="break"></span>
				What about Bill Clinton? He needs to see women suppressed, to humiliate themselves and forfeit their dominance in the most severe of ways. You can’t take that ability away from him, he will melt.
				</p>
				<p>
					<span class="douglas">Douglas:</span> That’s his problem. He should have dealt with his mother issues. The world would have been a better place that’s for sure.
				</p>
				<p class="h-l">
					H.L. I think there are many in that generation who did not deal with their pain.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes, but fortunately there are some who did.
				</p>
				<p class="h-l">
					H.L. So instead of focusing on the macro issues that were reducing abortion they focused on The Theorem instead?
				</p>
				<p>
					<span class="douglas">Douglas:</span> Essentially yes. The truth is The Theorem was never a front line book on abortion anyways. It just wasn’t.
				</p>
				<p class="h-l">
					H.L. But your initial advertising; your initial press release said otherwise. Was that deceptive?
				</p>
				<p>
					<span class="douglas">Douglas:</span> No, though I can see how it could have been disappointing to those who were looking for a book specifically out to defeat abortion. It is the most important pro-life book, but for the reasons I mentioned.
				</p>
				<p class="h-l">
					H.L.  Because neurobiologically and behaviorally; it emphasizes the role of the father with the daughter, if that criterion is met there will be no motivation for abortion. This is how I interpret what you just said. Correct?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Essentially yes. This is what still excites me the most about The Theorem. It is the single aspect of the model where we, as men, get a real role.
				<span class="break"></span>
				Here, between a father and a daughter we play a key role in not only her behavior, but her immune system and in her entire neurobiology. We have to be there. I think before The Theorem, some men instinctively knew that they needed to be there for their daughters. But others…
				</p>
				<p class="h-l">
					H.L. Others didn’t. They were less intuitive.
				</p>
				<p>
				<span class="douglas">Douglas:</span> That’s right. That’s it. And it is for those fathers who felt awkward or in the dark, The Theorem will be just what they need to get in the game.
				<span class="break"></span>
				We know, with neurobiological proof, we are necessary for our daughters. This is the one aspect where we are really needed. The rest of The Theorem is mostly dominated by the female, the mother. She has the neurobiological implications upon the child. But this is one spot for dads.
				</p>
				<p class="h-l">
					H.L. And as fathers we love projects. We like to be needed.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Sure. Build a deck, cut the lawn; restore our daughter’s self-esteem by telling her she is beautiful even on days when she feels she looks horrible. It’s all in a day’s work for tomorrow’s father.
				</p>
				<p class="h-l">
					H.L. Now we know.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, now we know.
				<span class="break"></span>
				This is where, in infancy and childhood, I can change society. This is where The Theorem can change society. But by the time the girl is at the front door of the abortion clinic, I can’t help her anymore. I just can’t.
				<span class="break"></span>
				In fact at that late stage, the equation tilts in the other direction, as The Theorem is overwhelming in its exploration of the effects of an unwanted child. You can kill a child in 15 minutes or over 15 years; it is sad. My goal is to never have the female take that walk, to want to make that choice in the first place.
				<span class="break"></span>
				But this idea of throwing copies of The Theorem at women when they walk into an abortion clinic or leaving copies of the book on their cars. That makes me ill. These are the horror stories I have heard in the past. This isn’t why I wrote The Theorem. This isn’t what it is all about.
				</p>
				<p class="h-l">
					H.L. So I guess the big question is then are you pro-choice or pro-life?
				</p>
				<p>
					<span class="douglas">Douglas:</span> Our President is Pro-life. He means a great deal to me, as you can imagine, after what the last administration did; so I am Pro-life.
				</p>
				<p class="h-l">
					H.L. That is an interesting answer.
				</p>
				<p>
					<span class="douglas">Douglas:</span> I do think a change is coming. I think that many of these women are going to realize they were duped and hustled out of their fetuses, for the likes of the Democratic Party.
				<span class="break"></span>
				I think there is going to be anger and backlash like you have never seen. Once these women figure out that they gave away the greatest gift, things are going to get ugly. And if you think the ‘Me Too’ movement was radical, wait until the ‘Me First’ movement or whatever they will call it.
				<span class="break"></span>
				So this is another reason why I typically tend to lean towards the Pro-life side of the fence.
				</p>
				<p class="h-l">
					H.L. I could see that occurring. The pendulum swings both ways. Certainly it is a tragedy. Well we may have gone off topic, but this was very interesting, actually beyond interesting it was amazing.
				</p>
				<p>
				<span class="douglas">Douglas:</span> We have a lot to cover tomorrow; should we wrap it up for the day?
				</p>
				<p class="h-l">
				H.L. Soon we should. You are forgetting to include the part about where you earned the knowledge, this insight into the minds of these twisted individuals.
				<span class="break"></span>
				We can’t forget that.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Right. We need to get to it today, tomorrow will be too busy. I think I can weave it into those eight years between 2006 and 2014; between when the book was published, and when I composed <span class="italic">The Legacy Letter</span>.
				<span class="break"></span>
				That should save space and time.
				</p>
				<p class="h-l">
					H.L. Now you’re getting it. Go ahead.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes, well that is easier said than done. There is a truckload of pain in there. My life makes the Clintons look like they grew up in a nunnery.
				</p>
				<p class="h-l">
					H.L. Yes, it is always easier to see the flaws in others, rather than yourself. I wouldn’t want to be in your shoes now. But you can do it.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Okay, sure.
				<span class="break"></span>
				Well by the time the book, <span class="italic">The Theorem: A Complete Answer to Human Behavior</span> came out in 2006, I was exhausted. My struggle to get it written was epic, finding the right publisher was equally difficult. It was really a sad story of poverty, no running water and hunger.
				<span class="break"></span>
				Ultimately it was too much for my wife at the time. We packed up and moved to Holland, to a small Dutch Village near Amsterdam. The dilemma was that I had two older children with me from my first marriage. I was, with the help of my Dutch wife, raising them in the Northern Rockies at the time.
				<span class="break"></span>
				But their mother said they could not go to Europe to live. Besides, my children had endured enough of the poverty and -50 degree winters. So right away the family was split. I worked in Amsterdam illegally, but was not making near the money I needed to support us. So we ended up at her parents in the attic of their home in a small Dutch village. It was a very rough situation. My children in America were falling apart. I was torn and heartbroken.
				</p>
				<p class="h-l">
					H.L.  That sounds very sad.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Eventually I had to come back to America to make money and leave them there. It was the most difficult decision I have ever made, nothing else in my life has ever been even close. This is not an understatement. I was ripped in half.
				<span class="break"></span>
				Eventually my wife had enough of me. I think by then everyone had enough of me. I know I certainly had enough of me.
				</p>
				<p class="h-l">
					H.L. What exactly had you enough of?
				</p>
				<p>
					<span class="douglas">Douglas:</span> I had been using people for years. They were tired of it, and I was tired of it. My publisher felt used. My family felt used. Even the Pro-life community felt used, as it wasn’t really a Pro-life book. Of course it sucks to be used. Or as one blogger even stated, it stinks. They were really hurt. And you know what happens when you are being used. You know what you have to do when someone is using you?
				</p>
				<p class="h-l">
					H.L. You have to get away from them. Maybe change your number or move away. You are actually standing in the way of their progress if you enable them.
				</p>
				<p>
				<span class="douglas">Douglas:</span> That’s right. That is certainly not good for book sales when people stay away from you and your discovery.
				<span class="break"></span>
				Now looking back there were definitely forces beyond my control that were limiting the acceptance of the discovery developed in The Theorem, many forces. But I didn’t see that at the time and that was likely a good thing, as I had a lot of work to do on myself.
				<span class="break"></span>
				I was violently raped as a child by a babysitter. This happened on more than one occasion. She did a real number on my head. The end result was that I hated women. The way I used and treated them was carnal and disgusting. It was so bad that I was estranged from my own mother for years. She expected a lot out of her sons, but not that.
				<span class="break"></span>
				As bad as I was to women, I was probably worse to men. I was fighting with everyone, not just physically, but emotionally too. I would use men just the same. Every job I had I always made sure I took more than I gave.
				<span class="break"></span>
				I had been in therapy for years, at least 20 years by that time. It was not the typical therapy either. I stripped every part of me down to nothing, went back and relived every trauma. The problem was that I didn’t do it for the right reasons, the intense therapy. I didn’t do it to become a better boyfriend or husband, but instead to strip all the subjectivity out of myself so that I would not pollute the behavioral model of The Theorem. I was sick even in my intentions to get better.
				So the change had to come from my heart.
				<span class="break"></span>
				...And finally it did.
				<span class="break"></span>
				I made a vow to never use anyone again. I made a vow to give more than I would take, and I stuck to those vows. It wasn’t a perfect ascension, as there were lots of stops and starts, but I got there. Finally I could live with myself. Finally I can live with myself. But there is an awful lot of damage in my wake.
				<span class="break"></span>
				You know The Theorem is such a large discovery and encompasses every part of people’s lives. Someday a version of it will be available for even school children. I didn’t want the teachers to have to censor over the horror story of my biography for the kids. There is enough sickness in the first chapters; I didn’t want the last ones to end like that.
				</p>
				<p class="h-l">
					H.L. That is good you dealt with it. That’s a tragic story. Where were you when you did all of this for those 8 years?
				</p>
				<p>
					<span class="douglas">Douglas:</span> All over really. The problem was when I was in Europe, I felt I was breaking my kid’s hearts in the U.S. When I was in America, I felt I was breaking my kid’s hearts in Europe. So I just ran. I tried to stay out of both places as much as I could, so as to not hurt either. It was bizarre and twisted logic, but it was all my mind could come up with in response to that impossible decision.
				</p>
				<p class="h-l">
					H.L. Split up families can be hard, even if different cities.
				</p>
				<p>
					<span class="douglas">Douglas:</span> I just ran and ran until there were no more places to run to. To avoid the U.S. and Europe I spent a lot of time in Asia, Central and South America. The goal was that when I sent a postcard to my kids, they would realize I was not with the other children. I lived cheap; I lived poor, in places where I could accomplish that until I got better. I lived in conditions I don’t care to remember. I was sick, I was toxic and it took a long time to heal. It was no vacation.
				</p>
				<p class="h-l">
				H.L. No, it doesn’t sound like one.
				<span class="break"></span>
				When listening to this though I can’t help to think how much better off the world would be if Bill Clinton, or Hillary or even Barack Obama would had taken such an exodus to heal; rather than pollute others with their pain.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes, healing and self-discovery takes longer than most people think. It is a hard choice, and seems selfish.
				<span class="break"></span>
				On one hand you can stay in the situation you are in and try to minimize the damage to those around you, growing a little each day. However if the trauma is bad enough your very presence pollutes them; what you see as improvement is to them just a slight reduction in your sickness. It’s hard for them to get excited about that.
				<span class="break"></span>
				Perhaps the most tragic individual is the one who has started healing and believes that they are further along than they are. It is almost a carte blanche to stay sick then, they are going through the motions of healing, of dumping that trauma, but inside they are still sicker than most. I have fallen victim to this fallacy, as have those around me, at one time or another.
				</p>
				<p class="h-l">
					H.L. On the other hand?
				</p>
				<p>
					<span class="douglas">Douglas:</span> Well, it is self-explanatory; on the other hand you can run. You can distance yourself from those who were once around you. In some ways they benefit by the lack of your presence, of inflicting your sickness upon them. But it feels cowardly. Nobody likes to feel that way. Those you are trying to help, only feel deserted; abandoned.
				<span class="break"></span>
				I have tried it both ways, and I can’t tell which is better, or which is worse. All I can say is that you must do something, you must take action.
				<span class="break"></span>
				To try and hold it inside of you, it’s not going to work. Ultimately it is a testament to the fragility of childhood, the impressionability of what ultimately makes us so dynamic can also be programmed with abuse, trauma and a complete portfolio of pain. This then is stubborn to remove, a delicate surgery that one either foolishly attempts by themselves, or with the casual assistance of amateurish experts, who schedule you in-between bouts with self-discovery of their own damaged self.
				</p>
				<p class="h-l">
					H.L. Still, as you said, you have to do something.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Absolutely. You never get it right though. It is just different degrees of failure.
				<span class="break"></span>
				In a way it is endemic to our success. In America we are great at empire building. We really are one of the best countries at it. We have shot to prominence on the world stage with such speed and perfection. It is remarkable.
				<span class="break"></span>
				Take a look behind that perfection however, and you will find the truth; the real cost of our success. You simply can’t have it all. It is a myth we strive for but can never truly achieve. The cost is a Nation of unmet needs; arrested, if not frozen emotional development, and the sick repercussions of a subconscious mantra to achieve more, while giving less.
				<span class="break"></span>
				In this case, as we have seen here, these unmet needs are going to be responsible for severe damage to others.
				</p>
				<p class="h-l">
					H.L. You’re saying then, if I have this right, the Clintons are simply the price tag for the enormous growth we have experienced as a country in such a short time?
				</p>
				<p>
				<span class="douglas">Douglas:</span> I would agree with that yes. The environment of which they were allowed to flourish was not that unique than from the neighbors down the street.  Therefore, with nothing remarkable to take note of, to stand out, they are encouraged to thrive at whatever cost. It’s very possible.
				<span class="break"></span>
				One thing is certain, and that is we all pay the price for those left behind in the long run, somewhere down the line. It is a domino effect. We can’t escape the obligation, the burden. We must bring everyone with us; we can leave no one stranded. While we are our only as strong as our weakest link, we are only as healthy as our sickest individual.
				</p>
				<p class="h-l">
					H.L. About the book, The Theorem, did you realize it was being suppressed from 2008 onwards?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Of course I could feel it. The problem was it just seemed like an excuse to avoid getting better, so I played right into the governments hands. I was the perfect dupe. I was the perfect victim; silent, obedient and absent.
				<span class="break"></span>
				I had other problems as well. Big surprise I know, but my father was a real issue for me.
				</p>
				<p class="h-l">
					H.L. Really, I am actually surprised to hear that. How so?
				</p>
				<p>
					<span class="douglas">Douglas:</span> I had a father who was literally obsessed with me. He was very supportive of everything I did, except one. In many ways I was everything he was not. To him, I lived the life he didn’t have the courage to live.
				</p>
				<p class="h-l">
					H.L. But at the same time if he lived the life you did, how would you have turned out?
				</p>
				<p>
				<span class="douglas">Douglas:</span> That is exactly true, and a large part of the problem. Because I only made the discovery that I did, due to his guidance. Since I was a small child he told me what classic books to read. He taught me the discipline and the sacrifice it takes to write. He taught me how to balance a family with an artistic pursuit, which is an almost impossible task.
				<span class="break"></span>
				When he met my mother in Las Vegas, he was on his way to New York City to become a famous poet and playwright, and I think he would have accomplished that dream. But he put his dream on hold to start a family; he put it on hold for us. Still he wrote. And I am not exaggerating when I say this. He wrote for over 45 years, four hours every single morning. I doubt he missed more than 5 days a year.
				</p>
				<p class="h-l">
					H.L. You said he was never published.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Never. Then I come along, and not only get published, but complete something that is going to be remembered forever. It just seemed so unfair to him. So I spent a lot of time destroying my writing, so as not to hurt him.
				</p>
				<p class="h-l">
					H.L. Yet he was very supportive with everything else?
				</p>
				<p>
					<span class="douglas">Douglas:</span> He went above and beyond. If I got in a jam or ran out of money in another country, I knew I could just pick up the phone. He did every sport with us, even coaching many. There wasn’t anything he wouldn’t do for us. He even went bankrupt for me. Not many parents are willing to do that.
				</p>
				<p class="h-l">
					H.L. No, not many. But with writing it was different, it was his realm.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes. In the beginning, I would show him how good The Theorem was doing. He would say “But I want that to be my book”. It was sad. What do you say to that?
				</p>
				<p class="h-l">
				H.L.  Well there’s not much you can say. Stealing your father’s dream is not like stealing his car for a joyride with your best girlfriend.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Well said. No it’s not. It was more like, no son of mine.
				</p>
				<p class="h-l">
					H.L. Like that?
				</p>
				<p>
					<span class="douglas">Douglas:</span>  Yes, that bad. It was much more complex though.
				</p>
				<p class="h-l">
					H.L. How so?
				</p>
				<p>
				<span class="douglas">Douglas:</span> When I think of all the sacrifices he made for us. You know years ago, before the internet, the best resources for knowledge were the libraries and the encyclopedias.
				<span class="break"></span>
				While he would always take us to the library, we could not afford a good set of encyclopedias.  And he wanted the best for us, which at the time were Encyclopedia Britannicas.
				</p>
				<p class="h-l">
					H.L. Yes, I remember those.
				</p>
				<p>
				<span class="douglas">Douglas:</span> He was so determined to get us a set, but again we could not afford their high price tag. So he conjured up an idea to become a salesman for that company.
				<span class="break"></span>
				Now my father could do many things well, but sales were not one of them. He had to be the worst salesman in the world.
				</p>
				<p class="h-l">
					H.L. That bad?
				</p>
				<p>
					<span class="douglas">Douglas:</span> He was pathetic at it. Still he was determined to get us our deluxe set of Encyclopedias.
				<span class="break"></span>
				Often he would have potential customers come to our house. And from downstairs I could hear his sales pitch; his lack of self-confidence, and I would listen as he stumbled through and failed almost every rule of selling, to the point that I could almost predict the time when the potential customers would break free from his spiel and escape out the front door empty-handed.
				<span class="break"></span>
				I don’t think I ever loved him more than in those moments.
				</p>
				<p class="h-l">
					H.L. Sure, because you knew he was doing it for you and for your family. So did you ever get a set?
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes, it took him almost a year, and he finally was able to sell enough of them to get us our deluxe set of Encyclopedia Britannica’s at a discount. He quit the next day.
				</p>
				<p class="h-l">
					H.L. Fathers are something. But in the end that worked against you, like everything, there was a price.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, so compared to the mental blocks my father put on me, the governmental suppression was of small consequence.
				<span class="break"></span>
				Of course I did not understand the scope of that suppression at the time.
				</p>
				<p class="h-l">
					H.L. That is a very complex dynamic, when a son exceeds his father’s accomplishments. You see this unfolding quite often in professional sports.
				</p>
				<p>
					<span class="douglas">Douglas:</span> I imagine. That makes sense. It can be an issue in any discipline or profession, I can see that.
				</p>
				<p class="h-l">
					H.L. So are you ready to wrap this up? Like you say we have a large amount to cover tomorrow.
				</p>
				<p>
					<span class="douglas">Douglas:</span> Yes.
				</p>
				<p class="h-l">
					H.L. That was some astonishing work today <span class="douglas">Douglas:</span> I look forward to tomorrow.
				</p>
				<p>
					<span class="douglas">Douglas:</span> I am excited as well, tomorrow should be less painful.
				</p>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	export default {

	}
</script>

<style scoped>

</style>